(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  ready(function () {
    var root = document.querySelector('[data-feature="visualiser-v3-mobile"] .pdpv3m-root');
    if (!root || root.dataset.mobileVisualiserReady === 'true') return;
    var mobilePerfOptimized = window.__PDP_MOBILE_PERF_SETTING__ === true;
    var mobilePerfDebug = false;
    try {
      var perfParams = new URLSearchParams(window.location.search || '');
      var perfOverride = String(perfParams.get('pdpPerf') || '').toLowerCase();
      if (perfOverride === 'optimized') mobilePerfOptimized = true;
      if (perfOverride === 'legacy') mobilePerfOptimized = false;
      mobilePerfDebug = perfParams.get('pdpPerfDebug') === '1';
    } catch (_) {}
    var mobilePerfStats = window.__PDP_MOBILE_PERF_STATS__ = window.__PDP_MOBILE_PERF_STATS__ || {
      mode: mobilePerfOptimized ? 'optimized' : 'legacy',
      renderRequests: 0,
      renders: 0,
      deferredRenders: 0,
      skippedDuplicates: 0,
      imageFollowups: 0,
      mirrorSyncs: 0,
      mirrorDeferred: 0,
      mirrorSkippedDuplicates: 0
    };
    mobilePerfStats.mode = mobilePerfOptimized ? 'optimized' : 'legacy';

    function perfDebugLog(message, detail) {
      if (!mobilePerfDebug) return;
      try { console.log('[PDP perf]', message, detail || ''); } catch (_) {}
    }

    function perfMark(name) {
      if (!mobilePerfDebug || !window.performance || typeof window.performance.mark !== 'function') return;
      try { window.performance.mark('pdp-perf:' + name); } catch (_) {}
    }

    root.classList.remove('pdpv3-fallback-ready');
    root.dataset.mobileVisualiserReady = 'true';
    var visualiserFirstExperimentEnabled = !!document.querySelector('[data-product-images][data-visualiser-first-experiment="true"]');
    var autoSlideReadyAt = Date.now() + 2200;
    var lastTrustedVisualiserInputAt = 0;

    document.addEventListener('pointerdown', function (event) {
      if (!event || !event.isTrusted) return;
      if (!isVisualiserInputIntent(event.target)) return;
      lastTrustedVisualiserInputAt = Date.now();
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!event || !event.isTrusted) return;
      if (!isVisualiserInputIntent(document.activeElement)) return;
      lastTrustedVisualiserInputAt = Date.now();
    }, true);

    var els = {
      stage: root.querySelector('.pdpv3m-stage'),
      sceneImage: root.querySelector('.pdpv3m-scene-image'),
      art: root.querySelector('.pdpv3m-art'),
      artImage: root.querySelector('.pdpv3m-art-image'),
      agedOverlay: root.querySelector('.pdpv3m-aged-overlay'),
      bottom: root.querySelector('.pdpv3m-bottom'),
      metaWrap: root.querySelector('.pdpv3m-meta-wrap'),
      meta: root.querySelector('.pdpv3m-meta'),
      arButton: root.querySelector('#ar-lozenge-mobile'),
      compareGhost: root.querySelector('.pdpv3m-compare-ghost'),
      switchRow: root.querySelector('.pdpv3m-switch-row'),
      finishSwitch: root.querySelector('.pdpv3m-finish-switch'),
      toneSwitch: root.querySelector('.pdpv3m-tone-switch'),
      bottomRow: root.querySelector('.pdpv3m-bottom-row'),
      scenePicker: root.querySelector('.pdpv3m-scene-picker'),
      arBottomButton: root.querySelector('.pdpv3m-ar-fab--bottom'),
      showOptionsButton: root.querySelector('.pdpv3m-show-options-btn'),
      zoomButton: root.querySelector('.pdpv3m-stage-zoom'),
      measureLineW: root.querySelector('.pdpv3m-measure-line--width'),
      measureLineH: root.querySelector('.pdpv3m-measure-line--height'),
      measureLabelW: root.querySelector('.pdpv3m-measure-label--width'),
      measureLabelH: root.querySelector('.pdpv3m-measure-label--height')
    };
    var bootScrim = root.querySelector('[data-pdpv3m-loading-scrim]');
    var bootScrimDismissed = false;
    var bootScrimFailSafeTimer = null;

    function dismissBootScrim(force) {
      if (!bootScrim || bootScrimDismissed) return;
      if (!force) {
        var stageRect = els.stage && els.stage.getBoundingClientRect ? els.stage.getBoundingClientRect() : null;
        var artRect = els.art && els.art.getBoundingClientRect ? els.art.getBoundingClientRect() : null;
        var rootStyle = window.getComputedStyle ? window.getComputedStyle(root) : null;
        var hasStage = !!(stageRect && stageRect.width >= 120 && stageRect.height >= 120);
        var hasArt = !!(artRect && artRect.width >= 80 && artRect.height >= 80);
        var hasMountedCss = !!(rootStyle && rootStyle.position === 'absolute');
        if (!hasStage || !hasArt || !hasMountedCss) return;
      }
      bootScrim.style.display = 'none';
      bootScrimDismissed = true;
      if (bootScrimFailSafeTimer) {
        window.clearTimeout(bootScrimFailSafeTimer);
        bootScrimFailSafeTimer = null;
      }
    }

    if (bootScrim) {
      bootScrimFailSafeTimer = window.setTimeout(function () {
        dismissBootScrim(true);
      }, 3200);
    }

    var PRODUCT_IMAGES = {
      landscape: root.dataset.imageLandscape || '',
      portrait: root.dataset.imagePortrait || '',
      square: root.dataset.imageSquare || '',
      fallback: root.dataset.imageFallback || ''
    };
    var AGED_OVERLAYS = parseAgedOverlays();
    var SCALE_BACKGROUND_IMAGE = root.dataset.scaleImage || '';
    var FIXED_FRAME_THICKNESS_PX = 4;
    var SOFA_SCALE_FACTOR = 0.56;
    var SOFA_LANDSCAPE_BOOST = 1.22;
    var SOFA_PORTRAIT_MAX_HEIGHT_CM = 150;
    var SOFA_CENTER_Y_OFFSET_PX = 58;
    var SOFA_DESKTOP_SMALL_CENTER_Y_OFFSET_PX = 42;
    var SOFA_DESKTOP_CENTER_Y_OFFSET_PX = -36;
    var SOFA_TOP_BOUND_OFFSET_PX = 95;
    var SOFA_BOTTOM_BOUND_OFFSET_PX = 20;
    var EXACT_SCALE_REFERENCE_SOURCE_SIZE = 1024;
    var EXACT_SCALE_LEFT_BOUNDARY_PX = 130;
    var EXACT_SCALE_REFERENCE_TOP_PX = 100;
    var EXACT_SCALE_REFERENCE_BOTTOM_PX = 727;
    var EXACT_SCALE_REFERENCE_HEIGHT_CM = 200;
    var EXACT_SCENE_SOURCE_SIZE = 919;
    var EXACT_SCENE_TOP_PX = 30;
    var EXACT_SCENE_BOTTOM_INSET_PX = 200;
    var EXACT_SCENE_HEIGHT_PX = 696;
    var EXACT_SCENE_CENTER_PX = EXACT_SCENE_TOP_PX + (EXACT_SCENE_HEIGHT_PX / 2);
    var A_SERIES_SIZES_CM = {
      a0: { widthCm: 84.1, heightCm: 118.9 },
      a1: { widthCm: 59.4, heightCm: 84.1 },
      a2: { widthCm: 42.0, heightCm: 59.4 },
      a3: { widthCm: 29.7, heightCm: 42.0 },
      a4: { widthCm: 21.0, heightCm: 29.7 },
      a5: { widthCm: 14.8, heightCm: 21.0 },
      a6: { widthCm: 10.5, heightCm: 14.8 }
    };
    var FRAME_COLOR_MAP = {
      white: '#f6f2ea',
      black: '#141414',
      oak: '#d5b48a',
      'dark brown': '#6d4320',
      'antique gold': '#b89f63',
      'dark grey': '#4d4d4d',
      'dark gray': '#4d4d4d',
      'antique silver': '#6c6f73'
    };
    var SCENE_IMAGE_BOUNDS = {
      sofa: {
        sourceSize: 1024,
        top: 10,
        bottom: 479,
        left: 110,
        right: 110,
        centerX: 512,
        centerY: 277.5
      },
      blankwall: {
        sourceSize: 1024,
        top: 88,
        bottom: 132,
        left: 126,
        right: 126,
        centerX: 512,
        centerY: 490
      },
      gallery: {
        sourceSize: 1024,
        top: 150,
        bottom: 340,
        left: 320,
        right: 312,
        centerX: 520,
        centerY: 388
      },
      charcoal: {
        sourceSize: 1024,
        top: 90,
        bottom: 430,
        left: 220,
        right: 220,
        centerX: 512,
        centerY: 342
      }
    };

    var SCENES = {
      sofa: {
        type: root.dataset.sceneSofaImage ? 'image' : 'css',
        image: root.dataset.sceneSofaImage || ''
      },
      blankwall: {
        type: root.dataset.sceneBlankwallImage ? 'image' : 'css',
        image: root.dataset.sceneBlankwallImage || ''
      },
      gallery: {
        type: root.dataset.sceneGalleryImage ? 'image' : 'css',
        image: root.dataset.sceneGalleryImage || ''
      },
      charcoal: {
        type: root.dataset.sceneCharcoalImage ? 'image' : 'css',
        image: root.dataset.sceneCharcoalImage || ''
      }
    };
    var ENABLE_BLANKWALL_SCENE = String(root.dataset.enableBlankwallScene || '').toLowerCase() === 'true';
    if (!ENABLE_BLANKWALL_SCENE) delete SCENES.blankwall;

    function getUiLabel(key, fallback) {
      var dataKey = 'label' + key.charAt(0).toUpperCase() + key.slice(1);
      return root.dataset[dataKey] || fallback || '';
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char];
      });
    }

    var BLANKWALL_SCENE_THUMB = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">' +
        '<defs>' +
          '<linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="0%">' +
            '<stop offset="0%" stop-color="#e7e1d6"/>' +
            '<stop offset="18%" stop-color="#f3efe8"/>' +
            '<stop offset="82%" stop-color="#f3efe8"/>' +
            '<stop offset="100%" stop-color="#e7e1d6"/>' +
          '</linearGradient>' +
        '</defs>' +
        '<rect width="360" height="360" fill="url(#bg)"/>' +
      '</svg>'
    );

    function syncSceneThumb(activeSceneImage) {
      if (visualiserFirstExperimentEnabled) return;
      var thumbItem = document.querySelector('.custom-product__thumb-item--visualiser');
      if (!thumbItem) return;

      var thumbLink = thumbItem.querySelector('.product__thumb');
      var thumbBg = thumbItem.querySelector('img[data-visualiser-thumb-srcset]');
      if (!thumbLink || !thumbBg) return;

      var sceneThumbSrc = activeSceneImage || '';
      if (!sceneThumbSrc && state.view === 'styled' && state.scene === 'blankwall') {
        sceneThumbSrc = BLANKWALL_SCENE_THUMB;
      }
      if (!sceneThumbSrc) {
        sceneThumbSrc = root.dataset.sceneSofaImage || root.dataset.scaleImage || root.dataset.sceneGalleryImage || root.dataset.sceneCharcoalImage || '';
      }
      if (!sceneThumbSrc) return;

      var sceneThumbSrcset = sceneThumbSrc.indexOf('data:image') === 0
        ? sceneThumbSrc
        : (sceneThumbSrc + ' 360w');

      var isSceneSynced = thumbLink.getAttribute('data-visualiser-scene-sync') === 'true';
      var sameThumbState =
        isSceneSynced &&
        thumbLink.getAttribute('href') === sceneThumbSrc &&
        thumbLink.getAttribute('data-visualiser-thumb-href') === sceneThumbSrc &&
        thumbBg.getAttribute('src') === sceneThumbSrc &&
        thumbBg.getAttribute('srcset') === sceneThumbSrcset &&
        thumbBg.getAttribute('data-visualiser-thumb-srcset') === sceneThumbSrcset;
      if (sameThumbState) return;

      thumbLink.setAttribute('href', sceneThumbSrc);
      thumbLink.setAttribute('data-visualiser-thumb-href', sceneThumbSrc);
      thumbLink.setAttribute('data-visualiser-scene-sync', 'true');
      thumbBg.setAttribute('src', sceneThumbSrc);
      thumbBg.setAttribute('srcset', sceneThumbSrcset);
      thumbBg.setAttribute('data-visualiser-thumb-srcset', sceneThumbSrcset);
      thumbBg.classList.add('lazyloaded');
      thumbBg.classList.remove('lazyload');
      thumbBg.classList.remove('lazyautosizes');
    }

    function syncThumbArtworkPlacement(artLeft, artTop, artWidth, artHeight, stageWidth, stageHeight) {
      if (visualiserFirstExperimentEnabled) return;
      var thumbItem = document.querySelector('.custom-product__thumb-item--visualiser');
      if (!thumbItem) return;

      var thumbArt = thumbItem.querySelector('.custom-product-landscape-img-thumb');
      if (!thumbArt) return;
      if (!Number.isFinite(artLeft) || !Number.isFinite(artTop) || !Number.isFinite(artWidth) || !Number.isFinite(artHeight)) return;
      if (!Number.isFinite(stageWidth) || !Number.isFinite(stageHeight) || stageWidth <= 0 || stageHeight <= 0) return;

      var centerXPct = (artLeft / stageWidth) * 100;
      var centerYPct = (artTop / stageHeight) * 100;
      var widthPct = (artWidth / stageWidth) * 100;
      var heightPct = (artHeight / stageHeight) * 100;

      var nextLeft = clamp(centerXPct, 0, 100) + '%';
      var nextTop = clamp(centerYPct, 0, 100) + '%';
      var nextWidth = clamp(widthPct, 8, 100) + '%';
      var nextHeight = clamp(heightPct, 8, 100) + '%';
      var nextTransform = 'translate(-50%, -50%)';

      if (thumbArt.style.getPropertyValue('--vthumb-left') !== nextLeft) thumbArt.style.setProperty('--vthumb-left', nextLeft);
      if (thumbArt.style.getPropertyValue('--vthumb-top') !== nextTop) thumbArt.style.setProperty('--vthumb-top', nextTop);
      if (thumbArt.style.getPropertyValue('--vthumb-width') !== nextWidth) thumbArt.style.setProperty('--vthumb-width', nextWidth);
      if (thumbArt.style.getPropertyValue('--vthumb-height') !== nextHeight) thumbArt.style.setProperty('--vthumb-height', nextHeight);
      if (thumbArt.style.getPropertyValue('--vthumb-transform') !== nextTransform) thumbArt.style.setProperty('--vthumb-transform', nextTransform);
    }

    function getSuperZoomManifestUrl() {
      var manifestEl = document.querySelector('[data-dzi-manifest]');
      if (manifestEl && manifestEl.getAttribute) return manifestEl.getAttribute('data-dzi-manifest');
      var viewerEl = document.querySelector('.dzi-viewer[data-manifest]');
      if (viewerEl && viewerEl.getAttribute) return viewerEl.getAttribute('data-manifest');
      return null;
    }

    function tryOpenSuperZoomFromVisualiser() {
      var manifestUrl = getSuperZoomManifestUrl();
      if (!manifestUrl || typeof window.openDziModal !== 'function') return false;
      try {
        window.openDziModal(manifestUrl);
        return true;
      } catch (error) {
        return false;
      }
    }

    function getVisualiserProxyImage() {
      var slide = root && root.closest ? root.closest('.product-main-slide') : null;
      if (!slide || !slide.querySelector) return null;
      return slide.querySelector('.pdpv3-photoswipe-proxy');
    }

    function tryOpenPhotoSwipeFromVisualiserProxy() {
      var proxyImage = getVisualiserProxyImage();
      var PhotoSwipeCtor = window.PhotoSwipe;
      var PhotoSwipeUiCtor = window.PhotoSwipeUI_Default;
      var pswpElement = document.querySelector('.pswp');

      if (!proxyImage || !PhotoSwipeCtor || !PhotoSwipeUiCtor || !pswpElement) return false;

      var src = proxyImage.getAttribute('data-photoswipe-src') || proxyImage.currentSrc || proxyImage.src || '';
      if (!src) return false;

      var width = parseInt(proxyImage.getAttribute('data-photoswipe-width'), 10);
      var height = parseInt(proxyImage.getAttribute('data-photoswipe-height'), 10);

      if (!Number.isFinite(width) || width <= 0) width = proxyImage.naturalWidth || 1500;
      if (!Number.isFinite(height) || height <= 0) height = proxyImage.naturalHeight || 1500;

      // Some products fall back to square proxy metadata (e.g. 1500x1500).
      // Align PhotoSwipe dimensions with the currently rendered artwork ratio.
      var expectedRatio = getSourceImageAspectRatio();
      var currentRatio = width / Math.max(height, 1);
      if (expectedRatio && isFinite(expectedRatio) && expectedRatio > 0 && Math.abs(currentRatio - expectedRatio) > 0.08) {
        var baseEdge = Math.max(width, height, 2000);
        if (expectedRatio >= 1) {
          width = Math.round(baseEdge);
          height = Math.max(1, Math.round(baseEdge / expectedRatio));
        } else {
          height = Math.round(baseEdge);
          width = Math.max(1, Math.round(baseEdge * expectedRatio));
        }
      }

      var item = {
        msrc: proxyImage.currentSrc || proxyImage.src || src,
        src: src,
        w: width,
        h: height,
        el: proxyImage,
        initialZoomLevel: 0.5
      };

      var options = {
        allowPanToNext: false,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        index: 0,
        pinchToClose: false,
        preloaderEl: false,
        scaleMode: 'zoom',
        shareEl: false,
        tapToToggleControls: false,
        getThumbBoundsFn: function () {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = proxyImage.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      };

      try {
        var gallery = new PhotoSwipeCtor(pswpElement, PhotoSwipeUiCtor, [item], options);
        gallery.init();
        window.activePhotoswipeGallery = gallery;
        gallery.listen('destroy', function () {
          if (window.activePhotoswipeGallery === gallery) {
            window.activePhotoswipeGallery = null;
          }
        });
        return true;
      } catch (error) {
        return false;
      }
    }

    var defaultScene = String(root.dataset.defaultScene || root.dataset.scene || 'sofa').toLowerCase();
    if (!ENABLE_BLANKWALL_SCENE && defaultScene === 'blankwall') defaultScene = 'sofa';
    if (!SCENES[defaultScene]) defaultScene = 'sofa';

    var state = {
      scene: defaultScene,
      view: 'styled',
      sizeText: '',
      finishText: '',
      toneText: '',
      frameText: '',
      orientationText: '',
      orientation: 'portrait'
    };
    var stickyUi = {
      panel: root.closest('.custom-product-single__sticky') || document.querySelector('.custom-product-single__sticky'),
      compactActive: false,
      expanded: false,
      sceneCompactActive: false
    };
    var visualiserSeen = {};
    var optionRerenderTimeouts = [];
    var preloadedVisualiserImages = {};
    var pendingOffscreenRender = false;
    var optimizedRenderRaf = 0;
    var optimizedForceRender = false;
    var optimizedImageFollowup = false;
    var lastCompletedRenderSignature = '';
    var lastImageFollowupSignature = '';
    var optimizedRetryTimer = null;
    var visualiserConnection = (typeof navigator !== 'undefined' && (navigator.connection || navigator.mozConnection || navigator.webkitConnection)) || null;

    function isConstrainedConnection() {
      if (!visualiserConnection) return false;
      if (visualiserConnection.saveData) return true;
      var effectiveType = String(visualiserConnection.effectiveType || '').toLowerCase();
      return effectiveType === 'slow-2g' || effectiveType === '2g' || effectiveType === '3g';
    }
    var initStateRetryCount = 0;
    var initOrientationRetryCount = 0;

    if (els.showOptionsButton) {
      var showOptionsLabel = getUiLabel('showAllOptions', ((els.showOptionsButton.textContent || '').trim() || 'Show all options'));
      els.showOptionsButton.textContent = showOptionsLabel;
      els.showOptionsButton.hidden = true;
    }

    function pushVisualiserEvent(eventName, payload, dedupeKey) {
      if (!eventName) return;
      if (dedupeKey && visualiserSeen[dedupeKey]) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event: eventName,
        page_type: 'pdp',
        visualiser_type: 'mobile_v3'
      }, payload || {}));
      if (dedupeKey) visualiserSeen[dedupeKey] = true;
    }

    function setupVisualiserTracking() {
      if (!root) return;

      if ('IntersectionObserver' in window) {
        var viewObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            pushVisualiserEvent('visualiser_open', { trigger: 'viewport' }, 'mobile_open_once');
            viewObserver.disconnect();
          });
        }, { threshold: 0.35 });
        viewObserver.observe(root);
      } else {
        pushVisualiserEvent('visualiser_open', { trigger: 'fallback' }, 'mobile_open_once');
      }

      root.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (target.closest('.pdpv3m-finish-btn, .pdpv3m-finish-option')) {
          pushVisualiserEvent('visualiser_interaction', { control: 'finish', action: 'select' });
          return;
        }
        if (target.closest('.pdpv3m-tone-option')) {
          pushVisualiserEvent('visualiser_interaction', { control: 'tone', action: 'select' });
          return;
        }
        if (target.closest('.pdpv3m-show-options-btn')) {
          pushVisualiserEvent('visualiser_control_toggle', { control: 'sticky_options', state: 'expanded' });
          return;
        }
        if (target.closest('.pdpv3m-scene-option, [data-mobile-scene-btn]')) {
          pushVisualiserEvent('visualiser_interaction', { control: 'scene', action: 'select' });
          return;
        }
        if (target.closest('.pdpv3m-tone-trigger')) {
          window.setTimeout(function () {
            var trigger = root.querySelector('.pdpv3m-tone-trigger');
            var expanded = trigger && trigger.getAttribute('aria-expanded') === 'true';
            pushVisualiserEvent('visualiser_control_toggle', { control: 'tone_menu', state: expanded ? 'open' : 'closed' });
          }, 0);
          return;
        }
        if (target.closest('.pdpv3m-finish-trigger')) {
          window.setTimeout(function () {
            var trigger = root.querySelector('.pdpv3m-finish-trigger');
            var expanded = trigger && trigger.getAttribute('aria-expanded') === 'true';
            pushVisualiserEvent('visualiser_control_toggle', { control: 'finish_menu', state: expanded ? 'open' : 'closed' });
          }, 0);
          return;
        }
        if (target.closest('.pdpv3m-scene-trigger')) {
          window.setTimeout(function () {
            var trigger = root.querySelector('.pdpv3m-scene-trigger');
            var expanded = trigger && trigger.getAttribute('aria-expanded') === 'true';
            pushVisualiserEvent('visualiser_control_toggle', { control: 'scene_menu', state: expanded ? 'open' : 'closed' });
          }, 0);
        }
      }, { capture: true, passive: true });
    }

    setupVisualiserTracking();

    function debounce(fn, wait) {
      var timeoutId;
      return function () {
        var args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          fn.apply(null, args);
        }, wait);
      };
    }

    function normalizeImageSrcValue(value) {
      var src = String(value || '').trim();
      if (!src) return '';
      try {
        var resolved = new URL(src, window.location.origin);
        return resolved.origin + resolved.pathname + resolved.search;
      } catch (error) {
        return src.replace(/^https?:/, '').replace(/^\/\//, '//');
      }
    }

    function setImageSrcIfChanged(img, nextSrc) {
      if (!img || !nextSrc) return false;
      var nextNorm = normalizeImageSrcValue(nextSrc);
      if (!nextNorm) return false;
      var currentNorm = normalizeImageSrcValue(
        img.getAttribute('src') || img.currentSrc || img.src || ''
      );
      if (currentNorm === nextNorm) return false;
      img.src = nextSrc;
      return true;
    }

    function scheduleOptionRerender() {
      if (mobilePerfOptimized) {
        requestRender();
        return;
      }
      optionRerenderTimeouts.forEach(function (timeoutId) {
        window.clearTimeout(timeoutId);
      });
      optionRerenderTimeouts = [
        window.setTimeout(function () {
          requestRender();
        }, 110)
      ];
    }

    function preloadImage(src) {
      if (!src || preloadedVisualiserImages[src]) return;
      var img = new Image();
      img.decoding = 'async';
      img.src = src;
      preloadedVisualiserImages[src] = img;
    }

    function preloadVisualiserImages(options) {
      options = options || {};
      var includeSceneBackgrounds = options.includeSceneBackgrounds === true;
      var constrained = isConstrainedConnection();
      preloadImage(getArtImageSrc());
      preloadImage(PRODUCT_IMAGES.fallback);

      if (constrained || !includeSceneBackgrounds) {
        return;
      }

      [
        PRODUCT_IMAGES.landscape,
        PRODUCT_IMAGES.portrait,
        PRODUCT_IMAGES.square,
        PRODUCT_IMAGES.fallback,
        SCALE_BACKGROUND_IMAGE
      ].forEach(preloadImage);

      if (includeSceneBackgrounds) {
        [
          SCENES.sofa && SCENES.sofa.image,
          SCENES.blankwall && SCENES.blankwall.image,
          SCENES.gallery && SCENES.gallery.image,
          SCENES.charcoal && SCENES.charcoal.image
        ].forEach(preloadImage);
      }

      if (includeSceneBackgrounds) {
        AGED_OVERLAYS.forEach(function (overlay) {
          preloadImage(overlay && overlay.src);
        });
      }
    }

    function scheduleVisualiserPreload(options) {
      var preloadOptions = options || {};
      if (isConstrainedConnection()) {
        window.setTimeout(function () {
          preloadVisualiserImages({ includeSceneBackgrounds: false });
        }, 1400);
        return;
      }
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () {
          preloadVisualiserImages(preloadOptions);
        }, { timeout: 2200 });
      } else {
        window.setTimeout(function () {
          preloadVisualiserImages(preloadOptions);
        }, 650);
      }
    }

    function clamp(num, min, max) {
      return Math.min(Math.max(num, min), max);
    }

    function lerp(min, max, t) {
      return min + (max - min) * t;
    }

    function normaliseRange(value, min, max) {
      if (!Number.isFinite(value)) return 0;
      if (max <= min) return 0;
      return clamp((value - min) / (max - min), 0, 1);
    }

    function getCheckedInput(selector) {
      return document.querySelector(selector + ' input[type="radio"]:checked');
    }

    function getTextFromInput(input) {
      if (!input) return '';
      var label = document.querySelector('label[for="' + input.id + '"]');
      var labelTextNode = label ? label.querySelector('.variant__button-label-text') : null;
      if (labelTextNode && labelTextNode.textContent) {
        return labelTextNode.textContent.trim();
      }
      if (label) {
        var labelText = label.textContent || '';
        var priceNode = label.querySelector('[data-pdp-size-price], [data-pdp-finish-delta], .variant__button-price');
        var priceText = priceNode && priceNode.textContent ? priceNode.textContent.trim() : '';
        return (priceText ? labelText.replace(priceText, '') : labelText).trim();
      }
      return (input.value || '').trim();
    }

    function getSelectionDetails(input) {
      if (!input) {
        return { label: '', value: '' };
      }
      var label = document.querySelector('label[for="' + input.id + '"]');
      return {
        label: (label ? label.textContent : '').trim(),
        value: (input.value || '').trim()
      };
    }

    function getContainerSelectionDetails(containerSelector, inputName) {
      var field = document.querySelector(containerSelector);
      if (!field) return { label: '', value: '' };

      var inputSelector = inputName
        ? 'input[name="' + inputName.replace(/"/g, '\\"') + '"]'
        : 'input[type="radio"]';

      var checkedInput =
        field.querySelector(inputSelector + ':checked') ||
        document.querySelector(inputSelector + ':checked') ||
        field.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        return getSelectionDetails(checkedInput);
      }

      var selectedWrapper = field.querySelector(
        '.spb-productoptionswatchwrapper.selected,' +
        '.spb-productoptionswatchwrapper[aria-checked="true"],' +
        'label.selected,' +
        '[aria-checked="true"],' +
        '.is-selected,' +
        '.selected'
      );
      if (!selectedWrapper) {
        return { label: '', value: '' };
      }

      var wrapperInput = selectedWrapper.querySelector(inputSelector) || selectedWrapper.querySelector('input[type="radio"]');
      if (wrapperInput) {
        return getSelectionDetails(wrapperInput);
      }

      var labelText = (selectedWrapper.textContent || '').trim();
      return { label: labelText, value: labelText };
    }

    function getFirstSelectionDetails(candidates) {
      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        if (candidate && (candidate.value || candidate.label)) {
          return candidate;
        }
      }
      return { label: '', value: '' };
    }

    function getSelectedSizeText() {
      var source = getSizeFieldset() || document;
      var checked = source.querySelector('input[type="radio"]:checked') || getCheckedInput('fieldset[name="Size"]');
      if (checked) {
        var checkedText = getTextFromInput(checked);
        if (checkedText && parseSizeTextToCm(checkedText)) return checkedText;
      }

      var selectedNode = source.querySelector(
        '.variant-input.is-selected[data-value],' +
        '.variant-input.selected[data-value],' +
        '.variant-input[aria-checked="true"][data-value],' +
        '.spb-productoptionswatchwrapper.selected[data-value],' +
        '.spb-productoptionswatchwrapper[aria-checked="true"][data-value]'
      );
      if (selectedNode) {
        var selectedValue = (selectedNode.getAttribute('data-value') || '').trim();
        if (selectedValue && parseSizeTextToCm(selectedValue)) return selectedValue;
      }

      var featuredSize = getSizeTextFromFeaturedSizeExperiment();
      if (featuredSize) return featuredSize;

      var stickySize = getSizeTextFromStickySummary();
      if (stickySize) return stickySize;

      var metaText = (els.meta && els.meta.textContent ? els.meta.textContent : '').trim();
      if (metaText && parseSizeTextToCm(metaText)) return metaText;

      return '';
    }

    function getSizeTextFromFeaturedSizeExperiment() {
      var selectors = [
        '.pdp-featured-size.is-active[data-size-value]',
        '.pdp-featured-size[aria-pressed="true"][data-size-value]',
        '.um-featured-size.is-active[data-size-value]'
      ];
      for (var i = 0; i < selectors.length; i += 1) {
        var node = document.querySelector(selectors[i]);
        if (!node || !node.getAttribute) continue;
        var value = String(node.getAttribute('data-size-value') || '').trim();
        if (value && parseSizeTextToCm(value)) return value;
      }
      return '';
    }

    function getFeaturedSizePreviewTargets() {
      var card = document.querySelector('[data-pdp-featured-sizes], .um-featured-sizes-card');
      if (!card) return [];
      var buttons = Array.from(card.querySelectorAll('[data-featured-size-key][data-size-value]'));
      var targets = buttons.map(function (button) {
        if (!button || button.disabled || button.hidden) return null;
        var value = String(button.getAttribute('data-size-value') || '').trim();
        var dims = parseSizeTextToCm(value);
        if (!value || !dims) return null;
        var input = findSizeInputForValue(value);
        if (!input || input.disabled) return null;
        var nameNode = button.querySelector('.pdp-featured-size__name');
        var rawLabel = (nameNode && nameNode.textContent ? nameNode.textContent : button.getAttribute('data-featured-size-key') || '').trim();
        if (!rawLabel || rawLabel.toLowerCase() === 'selected') return null;
        return {
          key: button.getAttribute('data-featured-size-key') || '',
          label: 'Preview ' + rawLabel,
          target: {
            input: input,
            value: value,
            dims: dims,
            area: dims.widthCm * dims.heightCm
          }
        };
      }).filter(Boolean);

      targets.sort(function (a, b) {
        return a.target.area - b.target.area;
      });
      return targets;
    }

    function findSizeInputForValue(value) {
      var normalizedTarget = normalizeSizeValue(value);
      if (!normalizedTarget) return null;
      var options = getSizeOptionNodes();
      for (var i = 0; i < options.length; i += 1) {
        var option = options[i];
        if (normalizeSizeValue(option.value) === normalizedTarget) return option.input;
      }
      return null;
    }

    function getSizeTextFromStickySummary() {
      var selectors = [
        '[js-product="stickyAddToCartVariant"]',
        '.sticky-add-to-cart__variant',
        '.pdp-atc-selection-line',
        '.custom-product-single__sticky'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var el = document.querySelector(selectors[i]);
        var text = (el && el.textContent ? el.textContent : '').trim();
        if (!text) continue;
        if (parseSizeTextToCm(text)) return text;
      }

      return '';
    }

    function getSizeFieldset() {
      function isUsableFieldset(fieldset) {
        if (!fieldset) return false;
        if (fieldset.closest('[aria-hidden="true"], .hidden, [hidden]')) return false;
        return fieldset.offsetParent !== null;
      }

      var preferredSection = document.querySelector('.pdp-opt.pdp-opt--size, [data-pdp-pricing-size-section], [data-pdp-pricing-finish-first-size-slot]');
      if (preferredSection) {
        var preferredFieldset = preferredSection.querySelector('.variant-input-wrap[data-handle="size"], fieldset[data-handle="size"], fieldset[name="Size"]');
        if (isUsableFieldset(preferredFieldset)) return preferredFieldset;
      }

      var checked = getCheckedInput('fieldset[name="Size"]');
      var source = checked && checked.closest('.variant-input-wrap[data-handle="size"], fieldset[data-handle="size"], fieldset[name="Size"]');
      if (isUsableFieldset(source)) return source;

      var fieldsets = Array.from(document.querySelectorAll('.variant-input-wrap[data-handle="size"], fieldset[data-handle="size"], fieldset[name="Size"]')).filter(isUsableFieldset);

      return fieldsets.length ? fieldsets[0] : null;
    }

    function getSizeOptionNodes() {
      var source = getSizeFieldset() || document;
      return Array.from(source.querySelectorAll('.variant-input[data-value]')).map(function (node) {
        var input = node.querySelector('input[type="radio"]');
        return {
          node: node,
          input: input,
          value: ((node && node.getAttribute('data-value')) || input.value || '').trim()
        };
      }).filter(function (item) {
        return item.node && item.input && item.value;
      });
    }

    function scrollSizeFieldsetIntoView() {
      function openNearestDetails(node) {
        var current = node;
        while (current && current !== document.body) {
          if (current.tagName === 'DETAILS' && !current.open) {
            current.open = true;
          }
          current = current.parentElement;
        }
      }

      var preferredSizeSection = document.querySelector('.pdp-opt.pdp-opt--size');
      var source = preferredSizeSection || getSizeFieldset();
      var wrapper = source && (source.closest('.pdp-opt.pdp-opt--size, .variant-wrapper') || source);

      if (!wrapper) {
        var changeLink = document.getElementById('pdp-price-change');
        if (changeLink && typeof changeLink.click === 'function') {
          changeLink.click();
        }
        return;
      }

      openNearestDetails(wrapper);
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(function () {
        var focusTarget = wrapper.querySelector('input[type="radio"]:checked, input[type="radio"], button, [tabindex]:not([tabindex="-1"])');
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }, 260);
    }

    function getNonASizeCandidates() {
      return getSizeOptionNodes().map(function (item) {
        var input = item.input;
        var value = item.value;
        var dims = parseSizeTextToCm(value);
        return {
          node: item.node,
          input: input,
          value: value,
          dims: dims,
          area: dims ? (dims.widthCm * dims.heightCm) : 0
        };
      }).filter(function (candidate) {
        return candidate.input && !candidate.input.disabled && candidate.dims && !isASize(candidate.value);
      });
    }

    function normalizeSizeValue(text) {
      return String(text || '')
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/×/g, 'x')
        .replace(/"/g, 'in')
        .trim();
    }

    function getNamedTierTarget(name) {
      var candidates = getNonASizeCandidates();
      if (!candidates.length) return null;

      if (name === 'gallery') {
        candidates.sort(function (a, b) {
          return a.area - b.area;
        });
        return candidates[candidates.length - 1] || null;
      }

      var isSquareClassic = name === 'classic' && state.orientation === 'square';
      var isSquareStatement = name === 'statement' && state.orientation === 'square';
      var targetDimsList = name === 'classic'
        ? (isSquareClassic
          ? [{ widthCm: 45, heightCm: 45 }]
          : [{ widthCm: 45, heightCm: 60 }])
        : isSquareStatement
          ? [{ widthCm: 90, heightCm: 90 }]
          : [
          { widthCm: 60, heightCm: 90 },
          { widthCm: 60, heightCm: 80 },
          { widthCm: 60, heightCm: 75 }
        ];
      var aliases = name === 'classic'
        ? (isSquareClassic ? ['45x45cm', '18x18in'] : ['45x60cm', '18x24in'])
        : isSquareStatement
          ? ['90x90cm', '36x36in']
          : ['60x90cm', '60x80cm', '60x75cm', '24x36in', '24x32in', '24x30in'];

      var exact = candidates.find(function (candidate) {
        var normalized = normalizeSizeValue(candidate.value);
        return aliases.some(function (alias) {
          return normalized.indexOf(alias) !== -1;
        });
      });
      if (exact) return exact;

      var targetAreas = targetDimsList.map(function (targetDims) {
        return targetDims.widthCm * targetDims.heightCm;
      });
      var largestTargetArea = Math.max.apply(Math, targetAreas);
      var eligible = candidates.filter(function (candidate) {
        if (isSquareClassic || isSquareStatement) {
          var side = Math.max(candidate.dims.widthCm, candidate.dims.heightCm);
          var isSquare = Math.abs(candidate.dims.widthCm - candidate.dims.heightCm) < 0.75;
          var minSide = isSquareClassic ? 43 : 86;
          if (!isSquare || side < minSide) return false;
        }
        return candidate.area <= largestTargetArea + 0.5;
      });
      if (!eligible.length) return null;

      eligible.sort(function (a, b) {
        var aDiff = Math.min.apply(Math, targetAreas.map(function (targetArea) {
          return Math.abs(a.area - targetArea);
        }));
        var bDiff = Math.min.apply(Math, targetAreas.map(function (targetArea) {
          return Math.abs(b.area - targetArea);
        }));
        var diff = aDiff - bDiff;
        if (diff !== 0) return diff;
        return a.area - b.area;
      });
      return eligible[0] || null;
    }

    function getTierPreviewTarget() {
      var currentValue = getSelectedSizeText();
      if (!currentValue) {
        var current = getCheckedInput('fieldset[name="Size"]');
        currentValue = current ? (current.value || '') : '';
      }
      var currentDims = parseSizeTextToCm(currentValue || state.sizeText);
      var currentArea = currentDims ? (currentDims.widthCm * currentDims.heightCm) : 0;
      var tiers = getFeaturedSizePreviewTargets();
      var fallbackTiers = [
        { key: 'classic', label: 'Preview Classic', target: getNamedTierTarget('classic') },
        { key: 'statement', label: 'Preview Statement', target: getNamedTierTarget('statement') },
        { key: 'gallery', label: 'Preview Gallery', target: getNamedTierTarget('gallery') }
      ];
      if (!tiers.length) {
        tiers = fallbackTiers;
      } else {
        fallbackTiers.forEach(function (fallbackTier) {
          if (!fallbackTier || !fallbackTier.target || !fallbackTier.target.input) return;
          var hasTier = tiers.some(function (tier) {
            return tier.key === fallbackTier.key ||
              (tier.target && tier.target.input === fallbackTier.target.input);
          });
          if (!hasTier) tiers.push(fallbackTier);
        });
      }
      tiers = tiers.filter(function (tier) {
        return tier.target && tier.target.input;
      });

      tiers.sort(function (a, b) {
        return (a.target.area || 0) - (b.target.area || 0);
      });

      var seen = [];
      tiers = tiers.filter(function (tier) {
        if (seen.indexOf(tier.target.input) !== -1) return false;
        seen.push(tier.target.input);
        return true;
      });

      for (var i = 0; i < tiers.length; i += 1) {
        var tier = tiers[i];
        if (tier.target.input.checked) continue;
        if (tier.target.area > currentArea + 0.5) {
          return tier;
        }
      }

      return null;
    }

    function activateSizeInput(input, options) {
      if (!input || input.disabled) return;
      var opts = options || {};
      var preventLabelClick = opts.preventLabelClick === true;
      var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
      if (label && !preventLabelClick) {
        label.click();
        return;
      }
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('click', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getAllowedFinishKeys() {
      return [
        'map',
        'artprint',
        'framedmap',
        'framedartprint',
        'framedcanvasmap',
        'framedcanvas'
      ];
    }

    function getFinishFamily(key) {
      if (key === 'map' || key === 'artprint') return 'print';
      if (key === 'framedmap' || key === 'framedartprint') return 'framed';
      if (key === 'framedcanvasmap' || key === 'framedcanvas') return 'canvas';
      return '';
    }

    function getFinishFamilyLabel(family, grouped) {
      var printKey = grouped && grouped.print ? grouped.print.key : '';
      var group = grouped && grouped[family];
      var optionLabel = group && group.option ? group.option.label : '';
      if (optionLabel) return optionLabel;

      if (family === 'print') {
        return printKey === 'map' ? 'Map' : 'Art Print';
      }

      if (family === 'framed') {
        return printKey === 'map' ? 'Framed Map' : 'Framed Print';
      }

      if (family === 'canvas') return 'Canvas';
      return '';
    }

    function sanitizeFinishLabel(text) {
      var label = String(text || '').replace(/\s+/g, ' ').trim();
      if (!label) return '';
      label = label.replace(/from\s*[\£\$\€]\s*[\d,\.\s]+$/i, '').trim();
      label = label.replace(/[\£\$\€]\s*[\d,\.\s]+$/i, '').trim();
      label = label.replace(/from$/i, '').trim();
      return label;
    }

    function normalizeFinishOption(text) {
      var normalized = String(text || '')
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '')
        .trim();
      if (normalized === 'pushpinmap') return 'map';
      if (normalized === 'framedpushpinmap') return 'framedmap';
      return normalized;
    }

    function getVisibleFinishFieldsets() {
      return Array.from(document.querySelectorAll(
        '.variant-wrapper[data-handle="finish"] .variant-input-wrap,' +
        '.variant-input-wrap[data-handle="finish"],' +
        'fieldset[name="Finish"],' +
        'fieldset[name="Finition"]'
      )).filter(function (fieldset) {
        if (!fieldset) return false;
        if (fieldset.closest('[aria-hidden="true"], .hidden, [hidden]')) return false;
        return fieldset.offsetParent !== null;
      });
    }

    function getFinishOptionNodesFromSource(source) {
      if (!source) return [];

      return Array.from(source.querySelectorAll('.variant-input')).map(function (node) {
        var input = node.querySelector('input[type="radio"]');
        var label = input && input.id ? source.querySelector('label[for="' + input.id + '"]') : null;
        var labelTextNode = label ? label.querySelector('.variant__button-label-text') : null;
        var localizedLabel =
          (input && input.dataset ? input.dataset.localizedDisplayLabel : '') ||
          (node && node.getAttribute('data-localized-display-label')) ||
          (label && label.dataset ? label.dataset.localizedDisplayLabel : '') ||
          '';
        var labelText = sanitizeFinishLabel(
          localizedLabel ||
          (input && input.dataset ? input.dataset.displayLabel : '') ||
          (labelTextNode && labelTextNode.textContent) ||
          (label && label.textContent) ||
          (input && input.value) ||
          ''
        );
        var valueText = ((node && node.getAttribute('data-value')) || (input && input.value) || '').replace(/\s+/g, ' ').trim();
        return {
          node: node,
          input: input,
          value: valueText,
          label: labelText
        };
      }).filter(function (item) {
        return item.input && item.value;
      });
    }

    function getFinishFieldset() {
      var fieldsets = getVisibleFinishFieldsets();
      if (!fieldsets.length) return null;

      var allowed = getAllowedFinishKeys();
      var checkedSource = fieldsets.find(function (fieldset) {
        return fieldset.querySelector('input[type="radio"]:checked');
      });
      if (checkedSource) return checkedSource;

      var exactSource = fieldsets.find(function (fieldset) {
        var options = getFinishOptionNodesFromSource(fieldset);
        return options.length >= 2 && options.every(function (option) {
          return allowed.indexOf(normalizeFinishOption(option.value || option.label)) !== -1;
        });
      });

      return exactSource || fieldsets[0];
    }

    function getSelectedFinishText() {
      var source = getFinishFieldset();
      if (!source) return '';

      var selected = source.querySelector('input[type="radio"]:checked');
      if (!selected) return '';

      var node = selected.closest('.variant-input');
      return (((node && node.getAttribute('data-value')) || selected.value) || '').replace(/\s+/g, ' ').trim();
    }

    function getFinishOptionNodes() {
      return getFinishOptionNodesFromSource(getFinishFieldset());
    }

    function holdStickyOpen() {
      window.__pdpv3HoldStickyUntil = Date.now() + 2500;
    }

    function getFinishSwitchItems() {
      var options = getFinishOptionNodes();
      var allowed = getAllowedFinishKeys();
      var safe = options.length >= 2 && options.every(function (option) {
        return allowed.indexOf(normalizeFinishOption(option.value || option.label)) !== -1;
      });

      if (!safe) return [];

      var grouped = {};
      options.forEach(function (option) {
        var key = normalizeFinishOption(option.value || option.label);
        var family = getFinishFamily(key);
        if (!family) return;
        if (!grouped[family]) {
          grouped[family] = {
            family: family,
            key: key,
            option: option
          };
        }
        if (option.input && option.input.checked) {
          grouped[family].option = option;
        }
      });

      return ['print', 'framed', 'canvas'].map(function (family) {
        if (!grouped[family]) return null;
        grouped[family].label = getFinishFamilyLabel(family, grouped);
        return grouped[family];
      }).filter(Boolean);
    }

    function syncFinishSwitch() {
      if (!els.finishSwitch) return;

      els.finishSwitch.classList.remove('is-open');
      if (els.switchRow) els.switchRow.classList.remove('is-finish-open');

      var items = getFinishSwitchItems();
      if (items.length < 2) {
        els.finishSwitch.hidden = true;
        els.finishSwitch.style.display = 'none';
        els.finishSwitch.innerHTML = '';
        return;
      }

      var activeItem = items.find(function (item) {
        return item.option && item.option.input && item.option.input.checked;
      }) || items[0];
      var alternateItems = items.filter(function (item) {
        return item.family !== activeItem.family;
      });

      els.finishSwitch.hidden = false;
      els.finishSwitch.style.display = 'inline-flex';
      els.finishSwitch.classList.add('notranslate');
      els.finishSwitch.setAttribute('translate', 'no');
      els.finishSwitch.innerHTML =
        '<button type="button" class="pdpv3m-finish-trigger" aria-expanded="false">' +
          '<span class="pdpv3m-finish-prefix">Finish:</span>' +
          '<span class="pdpv3m-finish-current">' + escapeHtml(activeItem.label) + '</span>' +
        '</button>' +
        '<div class="pdpv3m-finish-menu" hidden>' +
          alternateItems.map(function (item) {
            return '<button type="button" class="pdpv3m-finish-option" data-finish-family="' + escapeHtml(item.family) + '">' + escapeHtml(item.label) + '</button>';
          }).join('') +
        '</div>';

      var triggerButton = els.finishSwitch.querySelector('.pdpv3m-finish-trigger');
      var menu = els.finishSwitch.querySelector('.pdpv3m-finish-menu');

      function closeMenu() {
        if (!triggerButton || !menu) return;
        els.finishSwitch.classList.remove('is-open');
        if (els.switchRow) els.switchRow.classList.remove('is-finish-open');
        triggerButton.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }

      function openMenu() {
        if (!triggerButton || !menu || !alternateItems.length) return;
        if (els.scenePicker) {
          els.scenePicker.classList.remove('is-open');
          if (els.bottomRow) els.bottomRow.classList.remove('is-scene-open');
          var sceneTrigger = els.scenePicker.querySelector('.pdpv3m-scene-trigger');
          var sceneMenu = els.scenePicker.querySelector('.pdpv3m-scene-menu');
          if (sceneTrigger) sceneTrigger.setAttribute('aria-expanded', 'false');
          if (sceneMenu) sceneMenu.hidden = true;
        }
        if (els.toneSwitch) {
          els.toneSwitch.classList.remove('is-open');
          if (els.bottomRow) els.bottomRow.classList.remove('is-tone-open');
          var toneTrigger = els.toneSwitch.querySelector('.pdpv3m-tone-trigger');
          var toneMenu = els.toneSwitch.querySelector('.pdpv3m-tone-menu');
          if (toneTrigger) toneTrigger.setAttribute('aria-expanded', 'false');
          if (toneMenu) toneMenu.hidden = true;
        }
        if (els.arBottomButton) els.arBottomButton.classList.remove('is-collapsed');
        els.finishSwitch.classList.add('is-open');
        if (els.switchRow) els.switchRow.classList.add('is-finish-open');
        triggerButton.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }

      if (triggerButton) {
        triggerButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          holdStickyOpen();
          if (els.finishSwitch.classList.contains('is-open')) closeMenu();
          else openMenu();
        });
      }

      if (menu) {
        menu.querySelectorAll('.pdpv3m-finish-option[data-finish-family]').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            holdStickyOpen();
            closeMenu();
            window.__pdpv3SuppressAutoSlideUntil = Date.now() + 900;
            window.__pdpv3SuppressStickyRedirectUntil = Date.now() + 1200;

            var finishFamily = button.getAttribute('data-finish-family');
            var item = items.find(function (entry) { return entry.family === finishFamily; });
            var target = item && item.option && item.option.input ? item.option.input : null;
            if (!target || target.checked) return;

            target.checked = true;
            requestRender(true);
            target.dispatchEvent(new Event('input', { bubbles: true }));
            target.dispatchEvent(new Event('click', { bubbles: true }));
            target.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      if (!els.finishSwitch.__finishOutsideListenerBound) {
        document.addEventListener('click', function (event) {
          if (!els.finishSwitch || !els.finishSwitch.classList.contains('is-open')) return;
          if (!els.finishSwitch.contains(event.target)) closeMenu();
        });
        els.finishSwitch.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') closeMenu();
        });
        els.finishSwitch.__finishOutsideListenerBound = true;
      }
    }

    function getVisibleToneContainers() {
      var proxyToneActive = !!document.querySelector('[data-pdp-aged-tone-proxy]');
      return Array.from(document.querySelectorAll(
        'div.option_colour_tone, .option_colour_tone'
      )).filter(function (container) {
        if (!container) return false;
        if (container.closest('[aria-hidden="true"], .hidden, [hidden]')) return false;
        return proxyToneActive || container.offsetParent !== null;
      });
    }

    function getStickyPanelElement() {
      var activePanel = document.querySelector('.custom-product-single__sticky.sticky-enabled');
      if (activePanel) {
        stickyUi.panel = activePanel;
        return activePanel;
      }
      if (stickyUi.panel && document.documentElement.contains(stickyUi.panel)) {
        return stickyUi.panel;
      }
      stickyUi.panel = root.closest('.custom-product-single__sticky') || document.querySelector('.custom-product-single__sticky');
      return stickyUi.panel;
    }

    function isMobileViewport() {
      return !!window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    }

    function isMobileEverywhereMode() {
      var modeContainer = root.closest('[data-pdpv3-visualiser-mode]');
      return !!(modeContainer && modeContainer.getAttribute('data-pdpv3-visualiser-mode') === 'mobile-everywhere');
    }

    function isRootSlideSelected() {
      var slide = root && root.closest ? root.closest('.product-main-slide') : null;
      if (!slide) return true;
      if (slide.getAttribute('aria-hidden') === 'true') return false;
      return slide.classList.contains('is-selected');
    }

    function shouldUseRoomViewShortcutButton() {
      if (!visualiserFirstExperimentEnabled) return false;
      if (!isMobileViewport()) return false;
      return isRootSlideSelected();
    }

    function shouldUseStickyCompactVisualiserUi() {
      if (!isMobileViewport()) return false;
      var panel = getStickyPanelElement();
      return !!(panel && panel.classList && panel.classList.contains('sticky-enabled'));
    }

    function shouldUseBlankwallCompactVisualiserUi() {
      if (!isMobileViewport() && !isMobileEverywhereMode()) return false;
      return state.view === 'styled' && state.scene === 'blankwall';
    }

    function closeInlineBottomMenus() {
      if (els.scenePicker) {
        els.scenePicker.classList.remove('is-open');
        var sceneTrigger = els.scenePicker.querySelector('.pdpv3m-scene-trigger');
        var sceneMenu = els.scenePicker.querySelector('.pdpv3m-scene-menu');
        if (sceneTrigger) sceneTrigger.setAttribute('aria-expanded', 'false');
        if (sceneMenu) sceneMenu.hidden = true;
      }

      if (els.toneSwitch) {
        els.toneSwitch.classList.remove('is-open');
        var toneTrigger = els.toneSwitch.querySelector('.pdpv3m-tone-trigger');
        var toneMenu = els.toneSwitch.querySelector('.pdpv3m-tone-menu');
        if (toneTrigger) toneTrigger.setAttribute('aria-expanded', 'false');
        if (toneMenu) toneMenu.hidden = true;
      }

      if (els.finishSwitch) {
        els.finishSwitch.classList.remove('is-open');
        if (els.switchRow) els.switchRow.classList.remove('is-finish-open');
        var finishTrigger = els.finishSwitch.querySelector('.pdpv3m-finish-trigger');
        var finishMenu = els.finishSwitch.querySelector('.pdpv3m-finish-menu');
        if (finishTrigger) finishTrigger.setAttribute('aria-expanded', 'false');
        if (finishMenu) finishMenu.hidden = true;
      }

      if (els.bottomRow) {
        els.bottomRow.classList.remove('is-scene-open');
        els.bottomRow.classList.remove('is-tone-open');
      }
      if (els.arBottomButton) els.arBottomButton.classList.remove('is-collapsed');
    }

    function syncStickyCompactUi() {
      var compactForSticky = shouldUseStickyCompactVisualiserUi();
      var compactForBlankwall = shouldUseBlankwallCompactVisualiserUi();
      var shouldCompact = compactForSticky || compactForBlankwall;
      var showAllOptionsLabel = root.dataset.labelShowAllOptions || 'Show all options';
      var viewOptionsLabel = root.dataset.labelViewOptions || 'View options';
      var roomViewLabel = root.dataset.labelRoomView || 'View in room ›';
      var useRoomViewShortcutButton = shouldUseRoomViewShortcutButton();

      if (compactForBlankwall && !stickyUi.sceneCompactActive) {
        stickyUi.expanded = false;
      }
      stickyUi.sceneCompactActive = compactForBlankwall;

      if (!shouldCompact) {
        stickyUi.compactActive = false;
        stickyUi.expanded = false;
        stickyUi.sceneCompactActive = false;
        root.classList.remove('pdpv3m-sticky-compact');
        root.classList.remove('pdpv3m-sticky-expanded');
        if (els.showOptionsButton) {
          els.showOptionsButton.hidden = true;
          els.showOptionsButton.textContent = showAllOptionsLabel;
          els.showOptionsButton.removeAttribute('aria-hidden');
          els.showOptionsButton.removeAttribute('tabindex');
        }
        return;
      }

      stickyUi.compactActive = true;
      root.classList.add('pdpv3m-sticky-compact');

      if (els.showOptionsButton) {
        els.showOptionsButton.hidden = false;
        els.showOptionsButton.textContent = useRoomViewShortcutButton ? roomViewLabel : viewOptionsLabel;
      }

      if (stickyUi.expanded) {
        root.classList.add('pdpv3m-sticky-expanded');
        if (els.showOptionsButton) {
          els.showOptionsButton.setAttribute('aria-hidden', 'true');
          els.showOptionsButton.setAttribute('tabindex', '-1');
        }
      } else {
        root.classList.remove('pdpv3m-sticky-expanded');
        if (els.showOptionsButton) {
          els.showOptionsButton.setAttribute('aria-hidden', 'false');
          els.showOptionsButton.removeAttribute('tabindex');
        }
        closeInlineBottomMenus();
      }
    }

    function normalizeToneOption(text) {
      return String(text || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '')
        .trim();
    }

    function getToneDisplayLabel(key, fallback) {
      if (key === 'original') return getUiLabel('toneOriginal', fallback || 'Original');
      if (key === 'aged') return getUiLabel('toneAged', fallback || 'Aged');
      return fallback || '';
    }

    function getToneOptionNodesFromSource(source) {
      if (!source) return [];

      return Array.from(source.querySelectorAll('input[name="properties[Colour tone]"]')).map(function (input) {
        var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
        var trigger = label || input.closest('label') || input.closest('.spb-productoptionswatchwrapper') || input.parentElement;
        var labelText = ((label && label.textContent) || input.value || '').replace(/\s+/g, ' ').trim();
        var valueText = (input.value || '').replace(/\s+/g, ' ').trim();
        return {
          input: input,
          label: labelText,
          value: valueText,
          key: normalizeToneOption(valueText || labelText),
          trigger: trigger
        };
      }).filter(function (item) {
        return item.input && item.key;
      });
    }

    function getToneSource() {
      var containers = getVisibleToneContainers();
      if (!containers.length) return null;
      return containers[0];
    }

    function getToneSwitchItems() {
      var source = getToneSource();
      var options = getToneOptionNodesFromSource(source);
      var keyed = {};

      options.forEach(function (option) {
        if (option.key.indexOf('original') !== -1) keyed.original = option;
        if (option.key.indexOf('aged') !== -1) keyed.aged = option;
      });

      return ['original', 'aged'].map(function (key) {
        if (!keyed[key]) return null;
        return {
          key: key,
          label: getToneDisplayLabel(key, keyed[key].label),
          input: keyed[key].input,
          trigger: keyed[key].trigger
        };
      }).filter(Boolean);
    }

    function shouldShowExpandedToneSwitch() {
      var isDesktopViewport = window.matchMedia('(min-width: 769px)').matches;
      return isMobileEverywhereMode() && isDesktopViewport;
    }

    function syncToneSwitch() {
      if (!els.toneSwitch) return;

      var items = getToneSwitchItems();
      if (items.length < 2) {
        els.toneSwitch.hidden = true;
        els.toneSwitch.style.display = 'none';
        els.toneSwitch.innerHTML = '';
        return;
      }

      var activeItem = items.find(function (item) { return item.input.checked; }) || items[0];
      var alternateItems = items.filter(function (item) { return item.key !== activeItem.key; });
      var useExpandedButtons = shouldShowExpandedToneSwitch();

      els.toneSwitch.hidden = false;
      els.toneSwitch.style.display = 'inline-flex';
      els.toneSwitch.classList.add('notranslate');
      els.toneSwitch.setAttribute('translate', 'no');
      if (useExpandedButtons) {
        els.toneSwitch.innerHTML = items.map(function (item) {
          var activeClass = item.key === activeItem.key ? ' is-active' : '';
          return '<button type="button" class="pdpv3m-tone-btn' + activeClass + '" data-tone-index="' + escapeHtml(item.key) + '" aria-pressed="' + (item.key === activeItem.key ? 'true' : 'false') + '">' + escapeHtml(item.label) + '</button>';
        }).join('');
      } else {
        els.toneSwitch.innerHTML =
          '<button type="button" class="pdpv3m-tone-trigger" aria-expanded="false">' +
            '<span class="pdpv3m-tone-prefix">' + escapeHtml(getUiLabel('tone', 'Tone')) + ':</span>' +
            '<span class="pdpv3m-tone-current">' + escapeHtml(activeItem.label) + '</span>' +
          '</button>' +
          '<div class="pdpv3m-tone-menu" hidden>' +
            alternateItems.map(function (item) {
              return '<button type="button" class="pdpv3m-tone-option" data-tone-index="' + escapeHtml(item.key) + '">' + escapeHtml(item.label) + '</button>';
            }).join('') +
          '</div>';
      }

      if (useExpandedButtons) {
        els.toneSwitch.querySelectorAll('.pdpv3m-tone-btn[data-tone-index]').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            holdStickyOpen();
            window.__pdpv3SuppressStickyRedirectUntil = Date.now() + 1200;
            var toneKey = button.getAttribute('data-tone-index');
            var item = items.find(function (entry) { return entry.key === toneKey; });
            var target = item && item.input ? item.input : null;
            if (!target || target.checked) return;
            target.checked = true;
            requestRender(true);
            target.dispatchEvent(new Event('input', { bubbles: true }));
            target.dispatchEvent(new Event('click', { bubbles: true }));
            target.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        return;
      }

      var triggerButton = els.toneSwitch.querySelector('.pdpv3m-tone-trigger');
      var menu = els.toneSwitch.querySelector('.pdpv3m-tone-menu');

      function closeMenu() {
        if (!triggerButton || !menu) return;
        els.toneSwitch.classList.remove('is-open');
        triggerButton.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }

      function openMenu() {
        if (!triggerButton || !menu || items.length < 2) return;
        if (els.scenePicker) {
          els.scenePicker.classList.remove('is-open');
          var otherTrigger = els.scenePicker.querySelector('.pdpv3m-scene-trigger');
          var otherMenu = els.scenePicker.querySelector('.pdpv3m-scene-menu');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherMenu) otherMenu.hidden = true;
        }
        if (els.finishSwitch) {
          els.finishSwitch.classList.remove('is-open');
          if (els.switchRow) els.switchRow.classList.remove('is-finish-open');
          var finishTrigger = els.finishSwitch.querySelector('.pdpv3m-finish-trigger');
          var finishMenu = els.finishSwitch.querySelector('.pdpv3m-finish-menu');
          if (finishTrigger) finishTrigger.setAttribute('aria-expanded', 'false');
          if (finishMenu) finishMenu.hidden = true;
        }
        els.toneSwitch.classList.add('is-open');
        triggerButton.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }

      if (triggerButton) {
        triggerButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          holdStickyOpen();
          if (els.toneSwitch.classList.contains('is-open')) closeMenu();
          else openMenu();
        });
      }

      if (menu) {
        menu.querySelectorAll('[data-tone-index]').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            holdStickyOpen();
            closeMenu();
            window.__pdpv3SuppressStickyRedirectUntil = Date.now() + 1200;
            var toneKey = button.getAttribute('data-tone-index');
            var item = items.find(function (entry) { return entry.key === toneKey; });
            var target = item && item.input ? item.input : null;
            if (!target) return;
            target.checked = true;
            requestRender(true);
            target.dispatchEvent(new Event('input', { bubbles: true }));
            target.dispatchEvent(new Event('click', { bubbles: true }));
            target.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      if (!els.toneSwitch.__toneOutsideListenerBound) {
        document.addEventListener('click', function (event) {
          if (!els.toneSwitch || !els.toneSwitch.classList.contains('is-open')) return;
          if (!els.toneSwitch.contains(event.target)) closeMenu();
        });
        els.toneSwitch.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') closeMenu();
        });
        els.toneSwitch.__toneOutsideListenerBound = true;
      }
    }

    function getSceneSwitchItems() {
      var items = [
        { key: 'sofa', label: getUiLabel('inRoom', 'In room') },
        { key: 'scale', label: getUiLabel('exactSize', 'Exact size') },
        { key: 'gallery', label: getUiLabel('galleryShort', 'Gallery') },
        { key: 'charcoal', label: getUiLabel('darkWall', 'Dark wall') }
      ];
      if (ENABLE_BLANKWALL_SCENE) items.splice(1, 0, { key: 'blankwall', label: getUiLabel('blankWall', 'Blank wall') });
      return items;
    }

    function syncSceneSwitch() {
      if (!els.scenePicker) return;

      var items = getSceneSwitchItems();
      var activeKey = state.view === 'scale' ? 'scale' : state.scene;
      var activeItem = items.find(function (item) { return item.key === activeKey; }) || items[0];
      var alternateItems = items.filter(function (item) { return item.key !== activeItem.key; });

      els.scenePicker.innerHTML =
        '<button type="button" class="pdpv3m-scene-trigger" aria-expanded="false">' +
          '<span class="pdpv3m-scene-prefix">' + escapeHtml(getUiLabel('scene', 'Scene')) + ':</span>' +
          '<span class="pdpv3m-scene-current">' + escapeHtml(activeItem.label) + '</span>' +
        '</button>' +
        '<div class="pdpv3m-scene-menu" hidden>' +
          alternateItems.map(function (item) {
            return '<button type="button" class="pdpv3m-scene-option" data-mobile-scene-btn="' + escapeHtml(item.key) + '">' + escapeHtml(item.label) + '</button>';
          }).join('') +
        '</div>';

      var triggerButton = els.scenePicker.querySelector('.pdpv3m-scene-trigger');
      var menu = els.scenePicker.querySelector('.pdpv3m-scene-menu');

      function closeMenu() {
        if (!triggerButton || !menu) return;
        els.scenePicker.classList.remove('is-open');
        if (els.bottomRow) els.bottomRow.classList.remove('is-scene-open');
        if (els.arBottomButton) els.arBottomButton.classList.remove('is-collapsed');
        triggerButton.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }

      function openMenu() {
        if (!triggerButton || !menu || !alternateItems.length) return;
        if (els.toneSwitch) {
          els.toneSwitch.classList.remove('is-open');
          if (els.bottomRow) els.bottomRow.classList.remove('is-tone-open');
          if (els.arBottomButton) els.arBottomButton.classList.remove('is-collapsed');
          var otherTrigger = els.toneSwitch.querySelector('.pdpv3m-tone-trigger');
          var otherMenu = els.toneSwitch.querySelector('.pdpv3m-tone-menu');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherMenu) otherMenu.hidden = true;
        }
        if (els.finishSwitch) {
          els.finishSwitch.classList.remove('is-open');
          if (els.switchRow) els.switchRow.classList.remove('is-finish-open');
          var finishTrigger = els.finishSwitch.querySelector('.pdpv3m-finish-trigger');
          var finishMenu = els.finishSwitch.querySelector('.pdpv3m-finish-menu');
          if (finishTrigger) finishTrigger.setAttribute('aria-expanded', 'false');
          if (finishMenu) finishMenu.hidden = true;
        }
        els.scenePicker.classList.add('is-open');
        if (els.bottomRow) els.bottomRow.classList.add('is-scene-open');
        if (els.arBottomButton) els.arBottomButton.classList.add('is-collapsed');
        triggerButton.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }

      if (triggerButton) {
        triggerButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          holdStickyOpen();
          if (els.scenePicker.classList.contains('is-open')) closeMenu();
          else openMenu();
        });
      }

      if (!els.scenePicker.__sceneOutsideListenerBound) {
        document.addEventListener('click', function (event) {
          if (!els.scenePicker || !els.scenePicker.classList.contains('is-open')) return;
          if (!els.scenePicker.contains(event.target)) closeMenu();
        });
        els.scenePicker.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') closeMenu();
        });
        els.scenePicker.__sceneOutsideListenerBound = true;
      }
    }

    function getSelectedToneText() {
      var selection = getFirstSelectionDetails([
        getContainerSelectionDetails('div.option_colour_tone', 'properties[Colour tone]'),
        getContainerSelectionDetails('.option_colour_tone', 'properties[Colour tone]')
      ]);
      return [selection.value, selection.label].filter(Boolean).join(' ').trim();
    }

    function getSelectedFrameText() {
      var selection = getFirstSelectionDetails([
        getContainerSelectionDetails('div.option_frame_colour_new', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour_new', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour_canvas', 'properties[Frame colour]')
      ]);
      return [selection.value, selection.label].filter(Boolean).join(' ').trim();
    }

    function getSelectedOrientationText() {
      return getTextFromInput(getCheckedInput('fieldset[name="Portrait or landscape?"]'));
    }

    function isASize(text) {
      return /^a\d+(\b|$)/i.test(String(text || '').trim());
    }

    function getDisplayUnitFromLabel(text) {
      var raw = (text || '').toLowerCase();
      if (/\bcm\b/.test(raw)) return 'cm';
      if (/\bmm\b/.test(raw)) return 'mm';
      if (/\bin\b/.test(raw) || /["]/.test(raw)) return 'in';
      return 'cm';
    }

    function getPreferredRawSizeMatch(raw) {
      if (!raw) return null;
      var regex = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)(?:\s*)(mm|cm|in)?/ig;
      var matches = [];
      var match;
      while ((match = regex.exec(raw)) !== null) {
        matches.push({
          width: match[1],
          height: match[2],
          unit: String(match[3] || '').toLowerCase()
        });
      }
      if (!matches.length) return null;

      for (var i = 0; i < matches.length; i += 1) {
        if (matches[i].unit === 'cm') return matches[i];
      }
      for (var j = 0; j < matches.length; j += 1) {
        if (matches[j].unit === 'mm') return matches[j];
      }
      for (var k = 0; k < matches.length; k += 1) {
        if (matches[k].unit === 'in') return matches[k];
      }
      return matches[0];
    }

    function parseSizeTextToCm(text) {
      var raw = (text || '').trim();
      if (!raw) return null;

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        if (A_SERIES_SIZES_CM[aKey]) {
          return {
            widthCm: A_SERIES_SIZES_CM[aKey].widthCm,
            heightCm: A_SERIES_SIZES_CM[aKey].heightCm,
            unit: 'mm'
          };
        }
      }

      var match = getPreferredRawSizeMatch(raw);
      if (!match) return null;

      var width = parseFloat(match.width);
      var height = parseFloat(match.height);
      var unit = match.unit || getDisplayUnitFromLabel(raw);

      if (unit === 'mm') {
        width /= 10;
        height /= 10;
      } else if (unit === 'in') {
        width *= 2.54;
        height *= 2.54;
      }

      return {
        widthCm: width,
        heightCm: height,
        unit: unit === 'mm' ? 'cm' : unit
      };
    }

    function formatSizeTextForMeta(rawText) {
      var raw = (rawText || '').trim();
      if (!raw) return '-';

      function formatMetaNumber(value) {
        var num = Number(value);
        if (!isFinite(num)) return String(value || '');
        if (Math.abs(num - Math.round(num)) < 0.000001) return String(Math.round(num));
        return String(num).replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
      }

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        var dims = A_SERIES_SIZES_CM[aKey];
        if (dims) {
          return aKey.toUpperCase() + ' (' + Math.round(dims.widthCm * 10) + 'x' + Math.round(dims.heightCm * 10) + 'mm)';
        }
      }

      var rawSizeMatch = getPreferredRawSizeMatch(raw);
      if (rawSizeMatch) {
        var widthValue = formatMetaNumber(rawSizeMatch.width);
        var heightValue = formatMetaNumber(rawSizeMatch.height);
        var unit = String(rawSizeMatch.unit || getDisplayUnitFromLabel(raw) || 'cm').toLowerCase();
        return widthValue + 'x' + heightValue + unit;
      }

      return raw.replace(/\s*x\s*/gi, 'x').replace(/\s+/g, '');
    }

    function getRawSizeDimsForMeta(rawText) {
      var raw = (rawText || '').trim();
      if (!raw) return null;

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        if (A_SERIES_SIZES_CM[aKey]) {
          return {
            widthCm: A_SERIES_SIZES_CM[aKey].widthCm,
            heightCm: A_SERIES_SIZES_CM[aKey].heightCm,
            unit: 'mm'
          };
        }
      }

      var match = getPreferredRawSizeMatch(raw);
      if (!match) return null;

      var width = parseFloat(match.width);
      var height = parseFloat(match.height);
      var unit = match.unit || getDisplayUnitFromLabel(raw);

      if (unit === 'mm') {
        width /= 10;
        height /= 10;
      } else if (unit === 'in') {
        width *= 2.54;
        height *= 2.54;
      }

      return {
        widthCm: width,
        heightCm: height,
        unit: unit
      };
    }

    function formatFramedSizeForMeta(rawText) {
      var rawDims = getRawSizeDimsForMeta(rawText);
      if (!rawDims) return '';
      var frameEachSideCm = rawDims.unit === 'in' ? 2.54 : 2;
      return formatDims(
        rawDims.widthCm + (frameEachSideCm * 2),
        rawDims.heightCm + (frameEachSideCm * 2),
        rawDims.unit
      );
    }

    function normaliseToneKey(toneText) {
      var key = (toneText || '').toLowerCase();
      if (document.querySelector('input[name="properties[Colour tone]"][value*="Aged"]:checked')) return 'aged';
      return key.indexOf('aged') !== -1 ? 'aged' : 'original';
    }

    function resolveFrameColor(frameText) {
      var key = (frameText || '').toLowerCase();
      if (!key) return '#181818';

      for (var mapKey in FRAME_COLOR_MAP) {
        if (Object.prototype.hasOwnProperty.call(FRAME_COLOR_MAP, mapKey) && key.indexOf(mapKey) !== -1) {
          return FRAME_COLOR_MAP[mapKey];
        }
      }

      return '#181818';
    }

    function inferOrientation(rawDimensions) {
      var fallbackSrc = PRODUCT_IMAGES.fallback || '';
      var dedicatedOrientations = [];

      ['landscape', 'portrait', 'square'].forEach(function (key) {
        var src = PRODUCT_IMAGES[key] || '';
        if (src && src !== fallbackSrc) {
          dedicatedOrientations.push(key);
        }
      });

      if (dedicatedOrientations.length === 1) {
        return dedicatedOrientations[0];
      }

      var hintedOrientation = getSlideOrientationHint();
      if (hintedOrientation) return hintedOrientation;

      var proxyRatio = getProxyImageAspectRatio();
      if (proxyRatio && Math.abs(proxyRatio - 1) > 0.04) {
        return proxyRatio > 1 ? 'landscape' : 'portrait';
      }

      if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        var ratio = els.artImage.naturalWidth / Math.max(els.artImage.naturalHeight, 1);
        if (ratio > 1.02) return 'landscape';
        if (ratio < 0.98) return 'portrait';
        return 'square';
      }

      if (rawDimensions && Math.abs(rawDimensions.widthCm - rawDimensions.heightCm) < 0.01) {
        return 'square';
      }
      if (rawDimensions && rawDimensions.widthCm > rawDimensions.heightCm) return 'landscape';
      if (rawDimensions && rawDimensions.heightCm > rawDimensions.widthCm) return 'portrait';
      return 'portrait';
    }

    function getSlideOrientationHint() {
      var slide = root && root.closest ? root.closest('.product-main-slide') : null;
      if (!slide || !slide.dataset) return '';

      var finishRaw = String(state.finishText || '').toLowerCase();
      var orderedHints = [];
      if (finishRaw.indexOf('fram') !== -1) {
        orderedHints.push(slide.dataset.mainProductImageFramedOrientation || '');
      } else {
        orderedHints.push(slide.dataset.mainProductImageUnframedOrientation || '');
      }
      orderedHints.push(slide.dataset.mainProductImageFramedOrientation || '');
      orderedHints.push(slide.dataset.mainProductImageUnframedOrientation || '');

      for (var i = 0; i < orderedHints.length; i += 1) {
        var value = String(orderedHints[i] || '').toLowerCase();
        if (value.indexOf('landscape') !== -1) return 'landscape';
        if (value.indexOf('portrait') !== -1) return 'portrait';
        if (value.indexOf('square') !== -1) return 'square';
      }

      return '';
    }

    function getProxyImageAspectRatio() {
      var proxyImage = root.closest('.product-main-slide') && root.closest('.product-main-slide').querySelector('.pdpv3-photoswipe-proxy');
      var proxyWidth = proxyImage ? Number(proxyImage.getAttribute('data-photoswipe-width')) : 0;
      var proxyHeight = proxyImage ? Number(proxyImage.getAttribute('data-photoswipe-height')) : 0;
      if (proxyWidth > 0 && proxyHeight > 0) {
        return proxyWidth / proxyHeight;
      }
      return 0;
    }

    function orientDims(dimensions, orientation) {
      if (!dimensions) return null;
      var width = dimensions.widthCm;
      var height = dimensions.heightCm;

      if (orientation === 'landscape' && height > width) {
        var widthSwap = width;
        width = height;
        height = widthSwap;
      }
      if (orientation === 'portrait' && width > height) {
        var heightSwap = width;
        width = height;
        height = heightSwap;
      }
      if (orientation === 'square') {
        var side = Math.min(width, height);
        width = side;
        height = side;
      }

      return { widthCm: width, heightCm: height, unit: dimensions.unit };
    }

    function formatValueForDisplay(value, unit) {
      if (!Number.isFinite(value)) return '-';
      if (unit === 'mm') {
        return String(Math.round(value * 10));
      }
      if (unit === 'in') {
        var inches = value / 2.54;
        var roundedInches = Math.round(inches * 10) / 10;
        return Number.isInteger(roundedInches) ? String(roundedInches) : roundedInches.toFixed(1);
      }
      var roundedCm = Math.round(value * 10) / 10;
      return Number.isInteger(roundedCm) ? String(roundedCm) : roundedCm.toFixed(1);
    }

    function formatDims(widthCm, heightCm, unit) {
      return formatValueForDisplay(widthCm, unit) + 'x' + formatValueForDisplay(heightCm, unit) + unit;
    }

    function getFrameThicknessCm(unit) {
      if (unit === 'mm') return 2;
      return unit === 'in' ? 2.54 : 2;
    }

    function getOuterDims(dimensions, finishKey) {
      if (!dimensions) return null;
      if (finishKey !== 'framed') return dimensions;

      var frameEachSideCm = dimensions.unit === 'in' ? 2.54 : 2;
      return {
        widthCm: dimensions.widthCm + (frameEachSideCm * 2),
        heightCm: dimensions.heightCm + (frameEachSideCm * 2),
        unit: dimensions.unit
      };
    }

    function getSourceImageAspectRatio() {
      if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        return els.artImage.naturalWidth / els.artImage.naturalHeight;
      }
      if (state.orientation === 'landscape') return 4 / 3;
      if (state.orientation === 'square') return 1;
      return 0.75;
    }

    function getProxyDimensionsCm(selectedDimensions, imageRatio) {
      if (!selectedDimensions || !imageRatio) return null;

      if (selectedDimensions.heightCm >= selectedDimensions.widthCm) {
        return {
          widthCm: selectedDimensions.heightCm * imageRatio,
          heightCm: selectedDimensions.heightCm
        };
      }

      return {
        widthCm: selectedDimensions.widthCm,
        heightCm: selectedDimensions.widthCm / imageRatio
      };
    }

    function getOrientationFromRenderedRatio(imageRatio, fallbackDimensions) {
      if (imageRatio) {
        if (Math.abs(imageRatio - 1) < 0.02) return 'square';
        return imageRatio > 1 ? 'landscape' : 'portrait';
      }
      return inferOrientation(fallbackDimensions);
    }

    function getRenderBox(selectedDimensions, stageWidth, stageHeight, view) {
      var widthNorm = normaliseRange(selectedDimensions.widthCm, 30, 300);
      var heightNorm = normaliseRange(selectedDimensions.heightCm, 30, 200);

      if (view === 'styled') {
        return {
          width: lerp(stageWidth * 0.18, stageWidth * 0.56, widthNorm),
          height: lerp(stageHeight * 0.28, stageHeight * 0.53, heightNorm)
        };
      }

      return {
        width: lerp(stageWidth * 0.24, stageWidth * 0.92, widthNorm),
        height: lerp(stageHeight * 0.32, stageHeight * 0.88, heightNorm)
      };
    }

    function getArtPixels(proxyDimensions, selectedDimensions, stageWidth, stageHeight, view) {
      var renderBox = getRenderBox(selectedDimensions, stageWidth, stageHeight, view);
      var fit = Math.min(
        renderBox.width / Math.max(proxyDimensions.widthCm, 1),
        renderBox.height / Math.max(proxyDimensions.heightCm, 1)
      );

      return {
        width: Math.max(20, Math.round(proxyDimensions.widthCm * fit)),
        height: Math.max(20, Math.round(proxyDimensions.heightCm * fit))
      };
    }

    function getFrameThicknessPx(proxyDimensions, artPixels, unit) {
      if (!proxyDimensions || !artPixels) return 0;
      return FIXED_FRAME_THICKNESS_PX;
    }

    function getSceneImageBounds(sceneKey, stageWidth, stageHeight) {
      var config = SCENE_IMAGE_BOUNDS[sceneKey];
      if (!config) return null;

      var scale = Math.max(stageWidth / config.sourceSize, stageHeight / config.sourceSize);
      var renderedSize = config.sourceSize * scale;
      var offsetX = (stageWidth - renderedSize) / 2;
      var offsetY = (stageHeight - renderedSize) / 2;

      return {
        scale: scale,
        offsetX: offsetX,
        offsetY: offsetY,
        left: offsetX + (config.left * scale),
        top: offsetY + (config.top * scale),
        width: (config.sourceSize - config.left - config.right) * scale,
        height: (config.sourceSize - config.top - config.bottom) * scale
      };
    }

    function getStyledScenePlacement(sceneKey, proxyDimensions, selectedDimensions, stageWidth, stageHeight) {
      var config = SCENE_IMAGE_BOUNDS[sceneKey];
      var bounds = getSceneImageBounds(sceneKey, stageWidth, stageHeight);
      if (!bounds) return null;

      if (sceneKey === 'charcoal' && proxyDimensions) {
        var charcoalSafeWidth = Math.max(20, bounds.width);
        var charcoalSafeHeight = Math.max(20, bounds.height);
        var charcoalCenterX = config.centerX ? (bounds.offsetX + (config.centerX * bounds.scale)) : (bounds.left + (bounds.width / 2));
        var charcoalCenterY = config.centerY ? (bounds.offsetY + (config.centerY * bounds.scale)) : (bounds.top + (bounds.height / 2));
        var charcoalIsLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;
        var charcoalIsPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
        var charcoalArtWidth;
        var charcoalArtHeight;

        if (charcoalIsPortrait) {
          var charcoalCappedPortraitHeightCm = Math.min(proxyDimensions.heightCm, SOFA_PORTRAIT_MAX_HEIGHT_CM);
          var charcoalPortraitPxPerCm = charcoalSafeHeight / Math.max(SOFA_PORTRAIT_MAX_HEIGHT_CM, 1);
          charcoalArtHeight = Math.max(20, Math.round(charcoalCappedPortraitHeightCm * charcoalPortraitPxPerCm));
          charcoalArtWidth = Math.max(
            20,
            Math.round(charcoalArtHeight * (proxyDimensions.widthCm / Math.max(proxyDimensions.heightCm, 1)))
          );
        } else {
          var charcoalSceneScale = Math.min(stageWidth / EXACT_SCENE_SOURCE_SIZE, stageHeight / EXACT_SCENE_SOURCE_SIZE);
          var charcoalPxPerCm = charcoalSceneScale * (EXACT_SCENE_HEIGHT_PX / 200);
          charcoalArtWidth = Math.max(20, Math.round(proxyDimensions.widthCm * charcoalPxPerCm * SOFA_SCALE_FACTOR));
          charcoalArtHeight = Math.max(20, Math.round(proxyDimensions.heightCm * charcoalPxPerCm * SOFA_SCALE_FACTOR));

          if (charcoalIsLandscape) {
            charcoalArtWidth = Math.max(20, Math.round(charcoalArtWidth * SOFA_LANDSCAPE_BOOST));
            charcoalArtHeight = Math.max(20, Math.round(charcoalArtHeight * SOFA_LANDSCAPE_BOOST));
          }
        }

        if (charcoalArtWidth > charcoalSafeWidth || charcoalArtHeight > charcoalSafeHeight) {
          var charcoalSafeFit = Math.min(
            charcoalSafeWidth / Math.max(charcoalArtWidth, 1),
            charcoalSafeHeight / Math.max(charcoalArtHeight, 1)
          );
          charcoalArtWidth = Math.max(20, Math.round(charcoalArtWidth * charcoalSafeFit));
          charcoalArtHeight = Math.max(20, Math.round(charcoalArtHeight * charcoalSafeFit));
        }

        return {
          width: charcoalArtWidth,
          height: charcoalArtHeight,
          left: charcoalCenterX,
          top: charcoalCenterY
        };
      }

      var scale = bounds.scale;
      var centerX = config.centerX ? (bounds.offsetX + (config.centerX * scale)) : (bounds.left + (bounds.width / 2));
      var centerY = config.centerY ? (bounds.offsetY + (config.centerY * scale)) : (bounds.top + (bounds.height / 2));
      var maxWidthFromCenter = 2 * Math.min(centerX - bounds.left, (bounds.left + bounds.width) - centerX);
      var maxHeightFromCenter = 2 * Math.min(centerY - bounds.top, (bounds.top + bounds.height) - centerY);

      if (sceneKey === 'blankwall' && proxyDimensions) {
        var blankwallIsLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;
        var blankwallIsPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
        var lockedBlankwallWidth = blankwallIsPortrait
          ? stageWidth
          : blankwallIsLandscape
            ? (stageWidth * 0.8)
            : (stageWidth * 0.84);
        var lockedBlankwallHeight = blankwallIsPortrait
          ? (stageHeight * 0.86)
          : blankwallIsLandscape
            ? stageHeight
            : (stageHeight * 0.84);
        var blankwallMaxWidthFromCenter = 2 * Math.min(centerX, stageWidth - centerX);
        var blankwallMaxHeightFromCenter = 2 * Math.min(centerY, stageHeight - centerY);
        var lockedBlankwallFit = Math.min(
          lockedBlankwallWidth / Math.max(proxyDimensions.widthCm, 1),
          lockedBlankwallHeight / Math.max(proxyDimensions.heightCm, 1),
          Math.max(20, blankwallMaxWidthFromCenter) / Math.max(proxyDimensions.widthCm, 1),
          Math.max(20, blankwallMaxHeightFromCenter) / Math.max(proxyDimensions.heightCm, 1)
        );
        return {
          width: Math.max(20, Math.round(proxyDimensions.widthCm * lockedBlankwallFit)),
          height: Math.max(20, Math.round(proxyDimensions.heightCm * lockedBlankwallFit)),
          left: centerX,
          top: centerY
        };
      }

      var widthNorm = normaliseRange(selectedDimensions.widthCm, 30, 300);
      var heightNorm = normaliseRange(selectedDimensions.heightCm, 30, 200);
      var minWidthFactor = sceneKey === 'gallery' ? 0.48 : 0.24;
      var minHeightFactor = sceneKey === 'gallery' ? 0.48 : 0.24;
      var maxWidthFactor = sceneKey === 'gallery' ? 1.06 : 0.98;
      var maxHeightFactor = sceneKey === 'gallery' ? 1.04 : 0.98;
      var preferredWidth = lerp(bounds.width * minWidthFactor, bounds.width * maxWidthFactor, widthNorm);
      var preferredHeight = lerp(bounds.height * minHeightFactor, bounds.height * maxHeightFactor, heightNorm);
      var fit = Math.min(
        preferredWidth / Math.max(proxyDimensions.widthCm, 1),
        preferredHeight / Math.max(proxyDimensions.heightCm, 1),
        Math.max(20, maxWidthFromCenter) / Math.max(proxyDimensions.widthCm, 1),
        Math.max(20, maxHeightFromCenter) / Math.max(proxyDimensions.heightCm, 1)
      );
      var artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * fit));
      var artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * fit));

      return {
        width: artWidth,
        height: artHeight,
        left: centerX,
        top: centerY
      };
    }

    function getExactScalePlacement(exactDimensions, proxyDimensions, stageWidth, stageHeight, finishKey) {
      if (!exactDimensions || !proxyDimensions) return null;

      var sceneScale = Math.min(
        stageWidth / EXACT_SCALE_REFERENCE_SOURCE_SIZE,
        stageHeight / EXACT_SCALE_REFERENCE_SOURCE_SIZE
      );
      var pxPerCm = sceneScale * (
        (EXACT_SCALE_REFERENCE_BOTTOM_PX - EXACT_SCALE_REFERENCE_TOP_PX) /
        EXACT_SCALE_REFERENCE_HEIGHT_CM
      );
      var exactBoxWidth = Math.max(20, exactDimensions.widthCm * pxPerCm);
      var exactBoxHeight = Math.max(20, exactDimensions.heightCm * pxPerCm);
      var artFit = Math.min(
        exactBoxWidth / Math.max(proxyDimensions.widthCm, 1),
        exactBoxHeight / Math.max(proxyDimensions.heightCm, 1)
      );
      var artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * artFit));
      var artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * artFit));
      var frameThicknessPx = finishKey === 'framed'
        ? getFrameThicknessPx(exactDimensions, { width: artWidth, height: artHeight }, exactDimensions.unit)
        : 0;
      var shellWidth = artWidth + (frameThicknessPx * 2);
      var shellHeight = artHeight + (frameThicknessPx * 2);
      var leftLimit = EXACT_SCALE_LEFT_BOUNDARY_PX * sceneScale;
      var topLimit = EXACT_SCALE_REFERENCE_TOP_PX * sceneScale;
      var bottomLimit = EXACT_SCALE_REFERENCE_BOTTOM_PX * sceneScale;
      var centerX = leftLimit + ((stageWidth - leftLimit) / 2);
      var centerY = topLimit + ((bottomLimit - topLimit) / 2);
      var artLeft = clamp(centerX, leftLimit + (shellWidth / 2), stageWidth - (shellWidth / 2));
      var artTop = clamp(centerY, topLimit + (shellHeight / 2), bottomLimit - (shellHeight / 2));

      return {
        width: artWidth,
        height: artHeight,
        left: artLeft,
        top: artTop
      };
    }

    function getSofaPlacement(proxyDimensions, stageWidth, stageHeight) {
      if (!proxyDimensions) return null;

      var bounds = getSceneImageBounds('sofa', stageWidth, stageHeight);
      if (!bounds) return null;
      var sofaConfig = SCENE_IMAGE_BOUNDS.sofa;

      var safeWidth = Math.max(20, bounds.width);
      var safeHeight = Math.max(20, bounds.height);
      var centerX = bounds.centerX || (bounds.left + (bounds.width / 2));
      var isLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;
      var isPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
      var isSquare = !isPortrait && !isLandscape;
      var artWidth;
      var artHeight;

      if (isPortrait) {
        var cappedPortraitHeightCm = Math.min(proxyDimensions.heightCm, SOFA_PORTRAIT_MAX_HEIGHT_CM);
        var portraitPxPerCm = safeHeight / Math.max(SOFA_PORTRAIT_MAX_HEIGHT_CM, 1);
        artHeight = Math.max(20, Math.round(cappedPortraitHeightCm * portraitPxPerCm));
        artWidth = Math.max(
          20,
          Math.round(artHeight * (proxyDimensions.widthCm / Math.max(proxyDimensions.heightCm, 1)))
        );
      } else if (isSquare) {
        var squareSideCm = Math.min(proxyDimensions.widthCm, proxyDimensions.heightCm);
        var squarePortraitPxPerCm = safeHeight / Math.max(SOFA_PORTRAIT_MAX_HEIGHT_CM, 1);
        var squareSidePx = Math.max(20, Math.round(squareSideCm * squarePortraitPxPerCm));
        artWidth = squareSidePx;
        artHeight = squareSidePx;
      } else {
        var sceneScale = Math.min(stageWidth / EXACT_SCENE_SOURCE_SIZE, stageHeight / EXACT_SCENE_SOURCE_SIZE);
        var pxPerCm = sceneScale * (EXACT_SCENE_HEIGHT_PX / 200);
        artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * pxPerCm * SOFA_SCALE_FACTOR));
        artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * pxPerCm * SOFA_SCALE_FACTOR));

        if (isLandscape) {
          artWidth = Math.max(20, Math.round(artWidth * SOFA_LANDSCAPE_BOOST));
          artHeight = Math.max(20, Math.round(artHeight * SOFA_LANDSCAPE_BOOST));
        }
      }

      if (artWidth > safeWidth || artHeight > safeHeight) {
        var safeFit = Math.min(
          safeWidth / Math.max(artWidth, 1),
          safeHeight / Math.max(artHeight, 1)
        );
        artWidth = Math.max(20, Math.round(artWidth * safeFit));
        artHeight = Math.max(20, Math.round(artHeight * safeFit));
      }

      var useDesktopSofaOffset = isMobileEverywhereMode() && !isMobileViewport();
      var desktopArtHeightRatio = artHeight / Math.max(safeHeight, 1);
      var sofaCenterYOffset = useDesktopSofaOffset
        ? lerp(SOFA_DESKTOP_SMALL_CENTER_Y_OFFSET_PX, SOFA_DESKTOP_CENTER_Y_OFFSET_PX, normaliseRange(desktopArtHeightRatio, 0.42, 0.72))
        : SOFA_CENTER_Y_OFFSET_PX;
      var centerY = sofaConfig && sofaConfig.centerY
        ? (bounds.offsetY + ((sofaConfig.centerY + sofaCenterYOffset) * bounds.scale))
        : (bounds.top + (bounds.height / 2));

      var desktopTopBoundOffset = useDesktopSofaOffset
        ? lerp(SOFA_TOP_BOUND_OFFSET_PX, 42, normaliseRange(desktopArtHeightRatio, 0.42, 0.72))
        : SOFA_TOP_BOUND_OFFSET_PX;
      var topLimit = bounds.top + (desktopTopBoundOffset * bounds.scale);
      var bottomLimit = bounds.top + bounds.height - (SOFA_BOTTOM_BOUND_OFFSET_PX * bounds.scale);
      var verticalSafeHeight = Math.max(20, bottomLimit - topLimit);

      if (artHeight > verticalSafeHeight) {
        var verticalFit = verticalSafeHeight / Math.max(artHeight, 1);
        artWidth = Math.max(20, Math.round(artWidth * verticalFit));
        artHeight = Math.max(20, Math.round(artHeight * verticalFit));
      }

      centerY = clamp(
        centerY,
        topLimit + (artHeight / 2),
        bottomLimit - (artHeight / 2)
      );

      return {
        width: artWidth,
        height: artHeight,
        left: centerX,
        top: centerY
      };
    }

    function triggerVendorAr() {
      var target = document.getElementById('ar-button') || document.querySelector('[rel="ar"]');
      if (!target) return false;

      if (target.classList) target.classList.add('ar-button--visually-hidden');

      if (typeof target.click === 'function') {
        target.click();
      } else {
        target.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      }

      return true;
    }

    function selectRoomViewSlide() {
      if (typeof window.__pdpv3SelectTargetVisualiserSlide === 'function') {
        if (window.__pdpv3SelectTargetVisualiserSlide('room-view-shortcut-button')) {
          return true;
        }
      }
      var carousel = document.querySelector('.product-slideshow');
      if (!carousel || !(window.Flickity && window.Flickity.data)) return false;
      var flkty = window.Flickity.data(carousel);
      if (!flkty || typeof flkty.select !== 'function') return false;

      var targetSlide = document.querySelector('.product-main-slide[data-main-product-image-unframed="true"]');
      if (!targetSlide) return false;

      var cellElements = typeof flkty.getCellElements === 'function' ? flkty.getCellElements() : [];
      var targetCellIndex = -1;
      for (var i = 0; i < cellElements.length; i += 1) {
        if (cellElements[i] === targetSlide) {
          targetCellIndex = i;
          break;
        }
      }
      if (targetCellIndex < 0) return false;

      try {
        flkty.select(targetCellIndex, false, true);
        return true;
      } catch (error) {
        return false;
      }
    }

    function jumpToVisualiserSlide() {
      if (window.__pdpv3SuppressAutoSlideUntil && Date.now() < window.__pdpv3SuppressAutoSlideUntil) return;
      if (Date.now() < autoSlideReadyAt) return;
      if (document.body && document.body.classList && document.body.classList.contains('page-booting')) return;
      if ((Date.now() - lastTrustedVisualiserInputAt) > 1500) return;
      if (typeof window.__pdpv3SelectVisualiserSlide !== 'function') return;
      if (window.__pdpv3SelectVisualiserSlide()) return;
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 120);
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 280);
    }

    function requestSlideIntent(intentKind) {
      if (visualiserFirstExperimentEnabled && typeof window.__pdpv3HandleSlideIntent === 'function') {
        if (window.__pdpv3HandleSlideIntent(intentKind)) return;
      }
      jumpToVisualiserSlide();
    }

    function readState() {
      state.sizeText = getSelectedSizeText();
      state.finishText = getSelectedFinishText();
      state.toneText = getSelectedToneText();
      state.frameText = getSelectedFrameText();
      state.orientationText = getSelectedOrientationText();
      state.orientationPendingImage = false;

      var orientationRaw = (state.orientationText || '').toLowerCase();
      var rawSizeDims = parseSizeTextToCm(state.sizeText);
      if (orientationRaw.indexOf('landscape') !== -1) state.orientation = 'landscape';
      else if (orientationRaw.indexOf('square') !== -1) state.orientation = 'square';
      else if (orientationRaw.indexOf('portrait') !== -1) state.orientation = 'portrait';
      else if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        state.orientation = inferOrientation(rawSizeDims);
      } else {
        state.orientationPendingImage = true;
      }
    }

    function renderScene() {
      var scene = SCENES[state.scene];
      if (!scene) return;

      root.dataset.scene = state.scene;
      root.dataset.sceneType = ((state.view === 'scale' && SCALE_BACKGROUND_IMAGE) || (state.view !== 'scale' && scene.type === 'image' && scene.image)) ? 'image' : 'css';

      var activeSceneImage = state.view === 'scale' ? SCALE_BACKGROUND_IMAGE : scene.image;
      syncSceneThumb(activeSceneImage);
      var useImageScene = root.dataset.sceneType === 'image' && activeSceneImage;
      var canLoadSceneMedia = isSlideShown();

      if (useImageScene && canLoadSceneMedia) {
        setImageSrcIfChanged(els.sceneImage, activeSceneImage);
        els.sceneImage.style.display = 'block';
        els.sceneImage.style.opacity = '1';
        els.sceneImage.style.visibility = 'visible';
        els.stage.style.backgroundImage = 'url("' + activeSceneImage.replace(/"/g, '\\"') + '")';
        els.stage.style.backgroundSize = 'cover';
        els.stage.style.backgroundPosition = 'center center';
        els.stage.style.backgroundRepeat = 'no-repeat';
      } else if (!useImageScene) {
        els.sceneImage.style.display = 'none';
        els.sceneImage.style.opacity = '0';
        els.sceneImage.style.visibility = 'hidden';
        els.stage.style.removeProperty('background-image');
        els.stage.style.removeProperty('background-size');
        els.stage.style.removeProperty('background-position');
        els.stage.style.removeProperty('background-repeat');
      }
    }

    function renderMeasurements(artLeft, artTop, artWidth, artHeight, dims, stageWidth) {
      var topY = Math.max(12, artTop - 16);
      els.measureLineW.style.left = artLeft + 'px';
      els.measureLineW.style.top = topY + 'px';
      els.measureLineW.style.width = artWidth + 'px';

      els.measureLabelW.textContent = formatValueForDisplay(dims.widthCm, dims.unit) + ' ' + dims.unit;
      els.measureLabelW.style.left = (artLeft + artWidth / 2) + 'px';
      els.measureLabelW.style.top = Math.max(0, topY - 18) + 'px';
      els.measureLabelW.style.transform = 'translate(-50%, 0)';

      var leftX = Math.max(10, artLeft - 14);
      els.measureLineH.style.left = leftX + 'px';
      els.measureLineH.style.top = artTop + 'px';
      els.measureLineH.style.height = artHeight + 'px';

      els.measureLabelH.textContent = formatValueForDisplay(dims.heightCm, dims.unit) + ' ' + dims.unit;
      els.measureLabelH.style.left = Math.max(4, leftX - 54) + 'px';
      els.measureLabelH.style.top = (artTop + artHeight / 2 - 12) + 'px';
      els.measureLabelH.style.transform = 'translate(0, 0)';

      if (artWidth < 100) {
        els.measureLabelW.style.left = Math.min(stageWidth - 56, artLeft + artWidth + 10) + 'px';
        els.measureLabelW.style.top = topY + 'px';
        els.measureLabelW.style.transform = 'translate(0, 0)';
      }
    }

    function resetCompareGhost() {
      if (!els.compareGhost) return;
      root.dataset.galleryGhost = 'false';
      root.dataset.galleryGhostTarget = '';
      root.dataset.galleryGhostCurrent = '';
      root.dataset.galleryGhostSize = '';
      els.compareGhost.dataset.hasGhost = 'false';
      els.compareGhost.style.width = '0px';
      els.compareGhost.style.height = '0px';
      els.compareGhost.style.opacity = '0';
    }

    function renderGalleryGhost(currentArtWidth, currentArtHeight, imageRatio, finishKey, stageWidth, stageHeight) {
      if (!els.compareGhost) return;

      var shouldShow = state.view === 'styled' && state.scene === 'sofa';
      var tier = getTierPreviewTarget();
      var target = tier && tier.target;
      if (!shouldShow || !tier || !target || target.input.checked) {
        resetCompareGhost();
        return;
      }

      var galleryDims = target.dims || parseSizeTextToCm(target.value);
      if (!galleryDims) {
        resetCompareGhost();
        return;
      }
      var currentDims = parseSizeTextToCm(state.sizeText);
      var currentArea = currentDims ? (currentDims.widthCm * currentDims.heightCm) : 0;
      var targetArea = galleryDims.widthCm * galleryDims.heightCm;
      var label = els.compareGhost.querySelector('.pdpv3m-compare-ghost-label');
      root.dataset.galleryGhostTarget = target.value;
      root.dataset.galleryGhostCurrent = state.sizeText || '';

      if (targetArea <= currentArea) {
        resetCompareGhost();
        return;
      }
      var targetMeasurementDims = state.view === 'scale'
        ? (orientDims(galleryDims, getOrientationFromRenderedRatio(imageRatio, galleryDims)) || galleryDims)
        : galleryDims;
      var targetProxy = getProxyDimensionsCm(targetMeasurementDims, imageRatio);
      if (!targetProxy) {
        resetCompareGhost();
        return;
      }

      var targetPlacement = state.view === 'scale'
        ? getExactScalePlacement(targetMeasurementDims, targetProxy, stageWidth, stageHeight, finishKey)
        : state.scene === 'sofa'
          ? getSofaPlacement(targetProxy, stageWidth, stageHeight)
          : getStyledScenePlacement(state.scene, targetProxy, galleryDims, stageWidth, stageHeight);
      var targetPixels = targetPlacement || getArtPixels(targetProxy, targetMeasurementDims, stageWidth, stageHeight, state.view);
      if (!targetPixels || !targetPixels.width || !targetPixels.height) {
        resetCompareGhost();
        return;
      }

      var ghostWidth = Math.round(targetPixels.width);
      var ghostHeight = Math.round(targetPixels.height);

      ghostWidth = Math.max(ghostWidth, currentArtWidth + 16);
      ghostHeight = Math.max(ghostHeight, currentArtHeight + 16);

      root.dataset.galleryGhost = 'true';
      root.dataset.galleryGhostSize = ghostWidth + 'x' + ghostHeight;
      els.compareGhost.dataset.hasGhost = 'true';
      els.compareGhost.style.width = ghostWidth + 'px';
      els.compareGhost.style.height = ghostHeight + 'px';
      els.compareGhost.style.opacity = '1';
      if (label) label.textContent = tier.label;
      els.compareGhost.setAttribute('aria-label', tier.label);
    }

    function getArtImageSrc() {
      if (state.orientation === 'landscape') {
        return PRODUCT_IMAGES.landscape || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.square || '';
      }
      if (state.orientation === 'square') {
        return PRODUCT_IMAGES.square || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.landscape || '';
      }
      return PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.landscape || PRODUCT_IMAGES.square || '';
    }

    function parseAgedOverlays() {
      var overlays = [];
      try {
        overlays = JSON.parse(root.dataset.agedOverlays || '[]');
      } catch (error) {
        overlays = [];
      }

      return overlays
        .map(function (overlay) {
          var ratio = Number(overlay && overlay.ratio);
          var src = overlay && overlay.src;
          if (!ratio || !src) return null;
          return { ratio: ratio < 1 ? 1 / ratio : ratio, src: src };
        })
        .filter(Boolean);
    }

    function getOverlayAspectRatio(dimensions) {
      if (dimensions && dimensions.width && dimensions.height) {
        return dimensions.width / Math.max(dimensions.height, 1);
      }

      if (dimensions && dimensions.widthCm && dimensions.heightCm) {
        return dimensions.widthCm / Math.max(dimensions.heightCm, 0.01);
      }

      if (state.orientation === 'landscape') return 1.5;
      if (state.orientation === 'square') return 1;
      return 0.6667;
    }

    function getClosestAgedOverlaySrc(dimensions) {
      var ratio = getOverlayAspectRatio(dimensions);
      var matchingRatio = ratio < 1 ? 1 / ratio : ratio;
      if (AGED_OVERLAYS.length) {
        var closestOverlay = AGED_OVERLAYS.reduce(function (closest, overlay) {
          if (!closest) return overlay;
          return Math.abs(overlay.ratio - matchingRatio) < Math.abs(closest.ratio - matchingRatio) ? overlay : closest;
        }, null);
        return {
          src: closestOverlay.src,
          ratio: closestOverlay.ratio,
          rotate: ratio < 0.98
        };
      }

      var src = ratio > 1.02
        ? root.dataset.overlayLandscape || root.dataset.overlaySquare || root.dataset.overlayPortrait || ''
        : ratio < 0.98
          ? root.dataset.overlayLandscape || root.dataset.overlaySquare || root.dataset.overlayPortrait || ''
          : root.dataset.overlaySquare || root.dataset.overlayLandscape || root.dataset.overlayPortrait || '';
      return {
        src: src,
        ratio: matchingRatio,
        rotate: ratio < 0.98
      };
    }

    function updateAgedOverlay(artWidth, artHeight) {
      var isAged = root.dataset.tone === 'aged';
      if (isAged) {
        var imageRect = els.artImage && els.artImage.getBoundingClientRect ? els.artImage.getBoundingClientRect() : null;
        var fallbackWidth = Number.isFinite(artWidth) ? artWidth : ((els.artImage && els.artImage.clientWidth) || (root.clientWidth * 0.4) || 1);
        var fallbackHeight = Number.isFinite(artHeight) ? artHeight : ((els.artImage && els.artImage.clientHeight) || (root.clientHeight * 0.4) || 1);
        var overlayBleedPx = root.dataset.finish === 'framed' ? 8 : 2;
        var overlayBox = {
          width: Math.max(1, Math.round(((imageRect && imageRect.width) || fallbackWidth) + overlayBleedPx)),
          height: Math.max(1, Math.round(((imageRect && imageRect.height) || fallbackHeight) + overlayBleedPx))
        };
        var overlay = getClosestAgedOverlaySrc(overlayBox);
        els.agedOverlay.style.setProperty('--pdpv3m-aged-overlay-image', overlay.src ? 'url("' + overlay.src + '")' : 'none');
        els.agedOverlay.dataset.rotate = overlay.rotate ? 'true' : 'false';
        els.agedOverlay.style.setProperty('--pdpv3m-overlay-width', overlayBox.width + 'px');
        els.agedOverlay.style.setProperty('--pdpv3m-overlay-height', overlayBox.height + 'px');
        var boxRatio = overlayBox.width / Math.max(overlayBox.height, 1);
        var normalizedBoxRatio = boxRatio < 1 ? (1 / Math.max(boxRatio, 0.01)) : boxRatio;
        var overlayRatio = Math.max(overlay.ratio || normalizedBoxRatio, 0.01);
        var ratioDelta = Math.abs(normalizedBoxRatio - overlayRatio) / overlayRatio;
        var bgWidth = 100;
        var bgHeight = 100;
        if (ratioDelta > 0.05) {
          var coverScale = Math.max(normalizedBoxRatio / overlayRatio, overlayRatio / normalizedBoxRatio);
          var stretchPercent = Math.max(0, (coverScale - 1) * 100);
          var easedStretchPercent = Math.ceil(stretchPercent * 0.55);
          var adjustedCoverPercent = Math.min(125, 100 + easedStretchPercent);
          if (boxRatio > overlayRatio) {
            bgWidth = adjustedCoverPercent;
          } else {
            bgHeight = adjustedCoverPercent;
          }
        }
        els.agedOverlay.style.setProperty('--pdpv3m-overlay-bg-width', bgWidth + '%');
        els.agedOverlay.style.setProperty('--pdpv3m-overlay-bg-height', bgHeight + '%');
      }
      els.agedOverlay.style.display = isAged ? 'block' : 'none';
    }

    function canRenderNow(allowHiddenSlide) {
      if (document.visibilityState === 'hidden') return false;
      if (!isRootInViewport()) return false;
      if (!allowHiddenSlide && visualiserSlide && !isSlideShown()) return false;
      return true;
    }

    function getRenderStateSignature() {
      var selected = [];
      document.querySelectorAll(
        'fieldset[name="Size"] input:checked, fieldset[name="Finish"] input:checked, ' +
        'fieldset[name="Portrait or landscape?"] input:checked, ' +
        'input[name="properties[Colour tone]"]:checked, input[name="properties[Frame colour]"]:checked'
      ).forEach(function (input) {
        selected.push(String(input.name || '') + '=' + String(input.value || input.id || ''));
      });
      return [
        selected.join('|'),
        state.scene || '',
        state.view || '',
        root.dataset.scene || '',
        root.dataset.view || '',
        root.dataset.finish || '',
        root.dataset.tone || '',
        window.innerWidth || 0,
        window.innerHeight || 0
      ].join('::');
    }

    function emitCompletedRender() {
      mobilePerfStats.renders += 1;
      perfMark('render-complete');
      if (!mobilePerfOptimized) {
        perfDebugLog('render-complete', { signature: 'legacy', stats: mobilePerfStats });
        return;
      }
      lastCompletedRenderSignature = getRenderStateSignature();
      root.setAttribute('data-pdp-perf-rendered', 'true');
      perfDebugLog('render-complete', {
        signature: lastCompletedRenderSignature,
        stats: mobilePerfStats
      });
      try {
        root.dispatchEvent(new CustomEvent('pdpv3:rendered', {
          detail: { signature: lastCompletedRenderSignature }
        }));
      } catch (_) {}
    }

    function flushDeferredRender() {
      if (!pendingOffscreenRender) return;
      if (!canRenderNow()) return;
      pendingOffscreenRender = false;
      if (mobilePerfOptimized) {
        requestRender();
      } else {
        render(false);
      }
    }

    function requestRender(force) {
      mobilePerfStats.renderRequests += 1;
      if (mobilePerfOptimized) {
        if (force === true) optimizedForceRender = true;
        if (optimizedRenderRaf) return;
        optimizedRenderRaf = window.requestAnimationFrame(function () {
          optimizedRenderRaf = 0;
          var forceThisRender = optimizedForceRender;
          if (!canRenderNow(forceThisRender)) {
            pendingOffscreenRender = true;
            mobilePerfStats.deferredRenders += 1;
            return;
          }
          var signature = getRenderStateSignature();
          var allowImageFollowup = optimizedImageFollowup && lastImageFollowupSignature !== signature;
          optimizedImageFollowup = false;
          if (!optimizedForceRender && !allowImageFollowup && signature === lastCompletedRenderSignature) {
            mobilePerfStats.skippedDuplicates += 1;
            perfMark('render-skipped-duplicate');
            return;
          }
          optimizedForceRender = false;
          if (allowImageFollowup) {
            lastImageFollowupSignature = signature;
            mobilePerfStats.imageFollowups += 1;
          }
          perfMark('render-start');
          render(forceThisRender);
        });
        return;
      }
      if (force === true) {
        pendingOffscreenRender = false;
        render(true);
        return;
      }
      if (!canRenderNow()) {
        pendingOffscreenRender = true;
        return;
      }
      pendingOffscreenRender = false;
      render(false);
    }

    function render(force) {
      var forceRender = force === true;
      if (!forceRender && !canRenderNow()) {
        pendingOffscreenRender = true;
        return;
      }
      readState();
      resetCompareGhost();
      root.dataset.ghostReady = 'true';
      syncStickyCompactUi();

      if (state.orientationPendingImage) {
        var pendingSrc = getArtImageSrc();
        setImageSrcIfChanged(els.artImage, pendingSrc);
        if (initOrientationRetryCount < 8) {
          initOrientationRetryCount += 1;
          if (mobilePerfOptimized) {
            if (optimizedRetryTimer) window.clearTimeout(optimizedRetryTimer);
            optimizedRetryTimer = window.setTimeout(requestRender, [60, 120, 200, 320, 500, 750, 1050, 1400][initOrientationRetryCount - 1]);
          } else {
            window.setTimeout(render, [60, 120, 200, 320, 500, 750, 1050, 1400][initOrientationRetryCount - 1]);
          }
        }
        return;
      }
      initOrientationRetryCount = 0;

      root.dataset.tone = normaliseToneKey(state.toneText);
      syncFinishSwitch();
      syncToneSwitch();
      syncSceneSwitch();

      var dims = parseSizeTextToCm(state.sizeText);
      if (!dims) {
        if (initStateRetryCount < 6) {
          initStateRetryCount += 1;
          if (mobilePerfOptimized) {
            if (optimizedRetryTimer) window.clearTimeout(optimizedRetryTimer);
            optimizedRetryTimer = window.setTimeout(requestRender, [80, 160, 280, 450, 700, 1000][initStateRetryCount - 1]);
          } else {
            window.setTimeout(render, [80, 160, 280, 450, 700, 1000][initStateRetryCount - 1]);
          }
        }
        renderScene();
        var earlyArtSrc = getArtImageSrc();
        if (earlyArtSrc) {
          setImageSrcIfChanged(els.artImage, earlyArtSrc);
          els.artImage.style.opacity = '1';
          els.artImage.style.visibility = 'visible';
          els.artImage.style.display = 'block';
        }
        updateAgedOverlay();
        return;
      }
      initStateRetryCount = 0;
      var physicalDims = state.view === 'scale'
        ? orientDims(dims, inferOrientation(dims))
        : dims;
      if (!physicalDims) return;

      var finishRaw = (state.finishText || '').toLowerCase();
      var finishKey = 'unframed';
      if (finishRaw.indexOf('canvas') !== -1) finishKey = 'canvas';
      else if (finishRaw.indexOf('fram') !== -1) finishKey = 'framed';

      root.dataset.view = state.view;
      root.dataset.finish = finishKey;
      renderScene();

      var artSrc = getArtImageSrc();
      if (artSrc) {
        setImageSrcIfChanged(els.artImage, artSrc);
        els.artImage.style.opacity = '1';
        els.artImage.style.visibility = 'visible';
        els.artImage.style.display = 'block';
      }

      var outerDims = getOuterDims(dims, finishKey);
      var metaText = formatSizeTextForMeta(state.sizeText);
      if ((finishKey === 'framed' || finishKey === 'canvas') && outerDims) {
        metaText = (formatFramedSizeForMeta(state.sizeText) || formatDims(outerDims.widthCm, outerDims.heightCm, outerDims.unit)) + ' (incl. frame)';
      }
      els.meta.textContent = metaText;

      var stageRect = els.stage.getBoundingClientRect();
      var stageWidth = stageRect.width || root.clientWidth || 320;
      var stageHeight = stageRect.height || root.clientHeight || 320;
      var imageRatio = getSourceImageAspectRatio() || 0.75;
      var proxy = getProxyDimensionsCm(physicalDims, imageRatio);
      if (!proxy) return;
      var measurementDims = physicalDims;
      if (state.view === 'scale') {
        measurementDims = orientDims(dims, getOrientationFromRenderedRatio(imageRatio, dims)) || physicalDims;
      }
      var labelDims = measurementDims;
      if (state.view === 'scale' && (finishKey === 'framed' || finishKey === 'canvas') && outerDims) {
        labelDims = orientDims(outerDims, getOrientationFromRenderedRatio(imageRatio, outerDims)) || outerDims;
      }

      var artPlacement = state.view === 'scale'
        ? getExactScalePlacement(measurementDims, proxy, stageWidth, stageHeight, finishKey)
        : state.scene === 'sofa'
          ? getSofaPlacement(proxy, stageWidth, stageHeight)
          : getStyledScenePlacement(state.scene, proxy, dims, stageWidth, stageHeight);
      var artPixels = artPlacement || getArtPixels(proxy, physicalDims, stageWidth, stageHeight, state.view);
      var artWidth = artPixels.width;
      var artHeight = artPixels.height;

      var artLeft = artPlacement ? artPlacement.left : stageWidth * 0.50;
      var artTop = artPlacement
        ? artPlacement.top
        : clamp(stageHeight * 0.30, artHeight / 2 + 10, stageHeight * 0.40);

      var frameThicknessPx = (finishKey === 'framed' || finishKey === 'canvas')
        ? getFrameThicknessPx(proxy, artPixels, dims.unit)
        : 0;
      var resolvedFrameColor = resolveFrameColor(state.frameText);

      root.style.setProperty('--pdpv3m-art-left', artLeft + 'px');
      root.style.setProperty('--pdpv3m-art-top', artTop + 'px');
      root.style.setProperty('--pdpv3m-art-width', artWidth + 'px');
      root.style.setProperty('--pdpv3m-art-height', artHeight + 'px');
      root.style.setProperty('--pdpv3m-frame-color', resolvedFrameColor);
      root.style.setProperty(
        '--pdpv3m-frame-thickness',
        frameThicknessPx + 'px'
      );
      if (finishKey === 'framed' && state.scene !== 'blankwall') {
        var slideTwoArtLongEdge = Math.max(artWidth, artHeight);
        var slideTwoSizeRatio = normaliseRange(slideTwoArtLongEdge, 160, 520);
        // In-room / styled scenes show the artwork much smaller than the
        // blank-wall hero, so framed map/art print needs a lighter visual frame.
        var slideTwoInsetPx = Math.max(
          frameThicknessPx,
          Math.round((frameThicknessPx * 3) - lerp(7.75, 1.75, slideTwoSizeRatio))
        );
        root.style.setProperty('--pdpv3m-slide2-framed-frame-width', slideTwoInsetPx + 'px');
      } else {
        root.style.removeProperty('--pdpv3m-slide2-framed-frame-width');
      }
      syncThumbArtworkPlacement(artLeft, artTop, artWidth, artHeight, stageWidth, stageHeight);
      updateAgedOverlay(artWidth, artHeight);

      var artDropShadow = '0 16px 32px rgba(0, 0, 0, 0.14)';
      var artAmbientShadow = '0 0 0 rgba(0, 0, 0, 0)';
      var wrapShadow = '0 20px 38px rgba(0, 0, 0, 0.14), 0 3px 12px rgba(0, 0, 0, 0.06)';
      var paperEdge = 'rgba(255, 255, 255, 0.18)';
      var paperSheenOpacity = '0.05';
      var canvasEdgeSize = '0px';
      var canvasEdgeHighlight = 'rgba(255, 255, 255, 0)';
      var canvasEdgeShadow = 'rgba(0, 0, 0, 0)';
      var useDesktopVisualTreatment = isMobileEverywhereMode() && !isMobileViewport();

      if (useDesktopVisualTreatment) {
        artDropShadow = '7px 22px 31px rgba(0, 0, 0, 0.115)';
        artAmbientShadow = '0 6px 14px rgba(0, 0, 0, 0.038)';
        wrapShadow = finishKey === 'framed'
          ? '8px 24px 34px rgba(0, 0, 0, 0.105), 0 6px 16px rgba(0, 0, 0, 0.034)'
          : '6px 20px 28px rgba(0, 0, 0, 0.088), 0 5px 14px rgba(0, 0, 0, 0.03)';
        paperEdge = 'rgba(255, 255, 255, 0.20)';
        paperSheenOpacity = finishKey === 'framed' ? '0.07' : '0.045';

        if (state.view === 'scale') {
          artDropShadow = finishKey === 'framed'
            ? '3px 12px 16px rgba(58, 43, 28, 0.075)'
            : '2px 10px 14px rgba(58, 43, 28, 0.062)';
          artAmbientShadow = '0 4px 10px rgba(0, 0, 0, 0.024)';
          wrapShadow = finishKey === 'framed'
            ? '4px 14px 18px rgba(58, 43, 28, 0.07), 0 4px 10px rgba(0, 0, 0, 0.026)'
            : '3px 12px 16px rgba(58, 43, 28, 0.053), 0 3px 8px rgba(0, 0, 0, 0.022)';
          paperEdge = 'rgba(255, 255, 255, 0.17)';
          paperSheenOpacity = finishKey === 'framed' ? '0.045' : '0.03';
        } else if (state.scene === 'gallery') {
          artDropShadow = finishKey === 'framed'
            ? '5px 18px 27px rgba(82, 60, 34, 0.128)'
            : '4px 16px 23px rgba(82, 60, 34, 0.098)';
          artAmbientShadow = '0 5px 12px rgba(61, 44, 23, 0.034)';
          wrapShadow = finishKey === 'framed'
            ? '6px 20px 30px rgba(86, 63, 35, 0.122), 0 5px 14px rgba(44, 29, 12, 0.034)'
            : '5px 16px 24px rgba(86, 63, 35, 0.088), 0 4px 12px rgba(44, 29, 12, 0.03)';
          paperEdge = 'rgba(255, 250, 239, 0.22)';
          paperSheenOpacity = finishKey === 'framed' ? '0.075' : '0.05';
        } else if (state.scene === 'charcoal') {
          artDropShadow = finishKey === 'framed'
            ? '8px 24px 36px rgba(0, 0, 0, 0.19)'
            : '6px 19px 28px rgba(0, 0, 0, 0.148)';
          artAmbientShadow = '0 6px 14px rgba(0, 0, 0, 0.064)';
          wrapShadow = finishKey === 'framed'
            ? '9px 28px 38px rgba(0, 0, 0, 0.175), 0 6px 16px rgba(0, 0, 0, 0.068)'
            : '7px 22px 32px rgba(0, 0, 0, 0.132), 0 5px 14px rgba(0, 0, 0, 0.055)';
          paperEdge = 'rgba(255, 245, 232, 0.14)';
          paperSheenOpacity = finishKey === 'framed' ? '0.05' : '0.03';
        }
      }

      if (finishKey === 'unframed') {
        artDropShadow = '0 0 0 rgba(0, 0, 0, 0)';
        artAmbientShadow = '0 0 0 rgba(0, 0, 0, 0)';
        wrapShadow = 'none';
        paperEdge = 'rgba(255, 255, 255, 0)';
        paperSheenOpacity = '0';
      } else if (finishKey === 'canvas') {
        artDropShadow = useDesktopVisualTreatment
          ? '0 8px 14px rgba(0, 0, 0, 0.16)'
          : '0 8px 14px rgba(0, 0, 0, 0.16)';
        artAmbientShadow = useDesktopVisualTreatment
          ? '0 22px 36px rgba(0, 0, 0, 0.10)'
          : '0 18px 30px rgba(0, 0, 0, 0.09)';
        wrapShadow = useDesktopVisualTreatment
          ? '0 2px 4px rgba(0, 0, 0, 0.07), 0 16px 28px rgba(0, 0, 0, 0.10)'
          : '0 2px 4px rgba(0, 0, 0, 0.06), 0 14px 26px rgba(0, 0, 0, 0.10)';
        paperEdge = 'rgba(255, 255, 255, 0.10)';
        paperSheenOpacity = '0.02';
        canvasEdgeSize = useDesktopVisualTreatment ? '10px' : '7px';
        canvasEdgeHighlight = useDesktopVisualTreatment ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.14)';
        canvasEdgeShadow = useDesktopVisualTreatment ? 'rgba(0, 0, 0, 0.14)' : 'rgba(0, 0, 0, 0.13)';

        if (state.scene === 'gallery') {
          artDropShadow = useDesktopVisualTreatment ? '0 8px 14px rgba(86, 63, 35, 0.15)' : '0 8px 14px rgba(82, 60, 34, 0.14)';
          artAmbientShadow = useDesktopVisualTreatment ? '0 20px 34px rgba(86, 63, 35, 0.12)' : '0 16px 28px rgba(61, 44, 23, 0.10)';
          wrapShadow = useDesktopVisualTreatment
            ? '0 2px 4px rgba(44, 29, 12, 0.06), 0 14px 26px rgba(86, 63, 35, 0.11)'
            : '0 2px 4px rgba(44, 29, 12, 0.06), 0 13px 24px rgba(86, 63, 35, 0.10)';
        } else if (state.scene === 'charcoal') {
          artDropShadow = useDesktopVisualTreatment ? '0 10px 18px rgba(0, 0, 0, 0.20)' : '0 10px 18px rgba(0, 0, 0, 0.22)';
          artAmbientShadow = useDesktopVisualTreatment ? '0 26px 40px rgba(0, 0, 0, 0.16)' : '0 20px 34px rgba(0, 0, 0, 0.15)';
          wrapShadow = useDesktopVisualTreatment
            ? '0 3px 6px rgba(0, 0, 0, 0.08), 0 18px 32px rgba(0, 0, 0, 0.14)'
            : '0 3px 5px rgba(0, 0, 0, 0.08), 0 16px 28px rgba(0, 0, 0, 0.14)';
          paperEdge = 'rgba(255, 245, 232, 0.08)';
          canvasEdgeHighlight = 'rgba(255, 245, 232, 0.10)';
        }
      }

      root.style.setProperty('--pdpv3m-art-drop-shadow', artDropShadow);
      root.style.setProperty('--pdpv3m-art-ambient-shadow', artAmbientShadow);
      root.style.setProperty('--pdpv3m-shadow', wrapShadow);
      root.style.setProperty('--pdpv3m-paper-edge', paperEdge);
      root.style.setProperty('--pdpv3m-paper-sheen-opacity', paperSheenOpacity);
      root.style.setProperty('--pdpv3m-canvas-edge-size', canvasEdgeSize);
      root.style.setProperty('--pdpv3m-canvas-edge-highlight', canvasEdgeHighlight);
      root.style.setProperty('--pdpv3m-canvas-edge-shadow', canvasEdgeShadow);

      renderMeasurements(
        artLeft - artWidth / 2,
        artTop - artHeight / 2,
        artWidth,
        artHeight,
        labelDims,
        stageWidth
      );
      renderGalleryGhost(artWidth, artHeight, imageRatio, finishKey, stageWidth, stageHeight);
      dismissBootScrim(false);
      emitCompletedRender();
    }

    if (els.scenePicker) {
      els.scenePicker.addEventListener('click', function (event) {
        var btn = event.target instanceof Element ? event.target.closest('[data-mobile-scene-btn]') : null;
        if (!btn) return;
        event.preventDefault();
        holdStickyOpen();
        var next = btn.dataset.mobileSceneBtn;
        if (!ENABLE_BLANKWALL_SCENE && next === 'blankwall') return;
        if (next === 'scale') {
          state.view = 'scale';
        } else {
          state.view = 'styled';
          state.scene = next;
        }
        els.scenePicker.classList.remove('is-open');
        if (els.bottomRow) els.bottomRow.classList.remove('is-scene-open');
        if (els.arBottomButton) els.arBottomButton.classList.remove('is-collapsed');
        requestRender(true);
      });
    }

    if (els.meta) {
      els.meta.addEventListener('click', function (event) {
        event.preventDefault();
        holdStickyOpen();
        scrollSizeFieldsetIntoView();
      });
    }

    if (els.compareGhost) {
      els.compareGhost.addEventListener('click', function (event) {
        event.preventDefault();
        holdStickyOpen();
        if (state.scene === 'blankwall') return;
        var tier = getTierPreviewTarget();
        if (tier && tier.target) {
          window.__pdpv3SuppressAutoSlideUntil = Date.now() + 900;
          window.__pdpv3SuppressStickyRedirectUntil = Date.now() + 1200;
          activateSizeInput(tier.target.input, { preventLabelClick: true });
        }
      });
    }

    if (els.arButton) {
      els.arButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (triggerVendorAr()) return;
        window.setTimeout(triggerVendorAr, 250);
      });
    }

    if (els.zoomButton) {
      els.zoomButton.addEventListener('click', function (event) {
        if (!(state.view === 'styled' && state.scene === 'blankwall')) return;
        holdStickyOpen();
        event.preventDefault();
        if (typeof event.stopPropagation === 'function') event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        if (tryOpenSuperZoomFromVisualiser()) return;
        tryOpenPhotoSwipeFromVisualiserProxy();
      }, true);
    }

    if (els.art) {
      function isBlankwallStyledView() {
        return state.view === 'styled' && state.scene === 'blankwall';
      }

      function consumeArtworkInteraction(event) {
        if (!isBlankwallStyledView()) return;
        if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
        if (event && typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }

      // Block Flickity/gallery click-handling from seeing blankwall artwork taps.
      els.art.addEventListener('pointerdown', consumeArtworkInteraction, true);
      els.art.addEventListener('mousedown', consumeArtworkInteraction, true);
      els.art.addEventListener('touchstart', consumeArtworkInteraction, true);

      els.art.addEventListener('click', function (event) {
        if (!isBlankwallStyledView()) return;
        event.preventDefault();
        if (typeof event.stopPropagation === 'function') event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        holdStickyOpen();

        // Reuse the same zoom flow as the magnifier button:
        // super zoom when available, otherwise PhotoSwipe fallback.
        if (els.zoomButton && typeof els.zoomButton.click === 'function') {
          els.zoomButton.click();
          return;
        }

        if (tryOpenSuperZoomFromVisualiser()) return;
        tryOpenPhotoSwipeFromVisualiserProxy();
      }, true);
    }

    if (els.showOptionsButton) {
      els.showOptionsButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        holdStickyOpen();
        if (shouldUseRoomViewShortcutButton()) {
          stickyUi.expanded = false;
          syncStickyCompactUi();
          if (selectRoomViewSlide()) return;
        }
        stickyUi.expanded = true;
        syncStickyCompactUi();
      });
    }

    var rerender = mobilePerfOptimized
      ? function () { requestRender(); }
      : debounce(function () { requestRender(); }, 80);

    document.querySelectorAll(
      'fieldset[name="Size"] input, fieldset[name="Finish"] input, fieldset[name="Portrait or landscape?"] input'
    ).forEach(function (el) {
      el.addEventListener('change', function () {
        requestSlideIntent(isSizeVariantControl(el) ? 'size' : 'variant');
        rerender();
      });
      el.addEventListener('click', function () {
        requestSlideIntent(isSizeVariantControl(el) ? 'size' : 'variant');
        if (mobilePerfOptimized) rerender();
        else window.setTimeout(rerender, 80);
      });
    });

    function isVisualiserVariantControl(el) {
      var wrap = el && el.closest && el.closest('.variant-wrapper, .variant-input-wrap, fieldset');
      var name = String((wrap && wrap.getAttribute('name')) || '').trim().toLowerCase();
      var handle = String((wrap && wrap.dataset && wrap.dataset.handle) || '').trim().toLowerCase();
      return name === 'size' || name === 'finish' || name === 'finition' || name === 'portrait or landscape?' || handle === 'size' || handle === 'finish' || handle === 'finition';
    }

    function isSizeVariantControl(el) {
      var wrap = el && el.closest && el.closest('.variant-wrapper, .variant-input-wrap, fieldset');
      var name = String((wrap && wrap.getAttribute('name')) || '').trim().toLowerCase();
      var handle = String((wrap && wrap.dataset && wrap.dataset.handle) || '').trim().toLowerCase();
      return name === 'size' || handle === 'size';
    }

    function isVisualiserInputIntent(el) {
      return isVisualiserVariantControl(el) || !!(el && el.closest && el.closest('[data-featured-size-key], div.option_colour_tone, div.option_frame_colour_new, .option_colour_tone, .option_frame_colour_new'));
    }

    document.querySelectorAll('.variant-input--pseudo, .variant-input--pseudo .pseudo-button, label.variant__button-label').forEach(function (el) {
      el.addEventListener('click', function () {
        if (!isVisualiserVariantControl(el)) return;
        requestSlideIntent(isSizeVariantControl(el) ? 'size' : 'variant');
      });
    });

    document.addEventListener('click', function (event) {
      var featuredSizeButton = event.target && event.target.closest
        ? event.target.closest('[data-featured-size-key][data-size-value]')
        : null;
      if (!featuredSizeButton) return;
      requestSlideIntent('size');
      rerender();
      if (!mobilePerfOptimized) {
        window.setTimeout(rerender, 120);
        window.setTimeout(rerender, 280);
      }
    }, true);

    document.querySelectorAll('div.option_colour_tone input, div.option_frame_colour_new input').forEach(function (el) {
      el.addEventListener('change', function () {
        requestSlideIntent('variant');
        rerender();
        scheduleOptionRerender();
      });
      el.addEventListener('click', function () {
        requestSlideIntent('variant');
        scheduleOptionRerender();
      });
    });

    document.querySelectorAll('div.option_colour_tone, div.option_frame_colour_new').forEach(function (el) {
      el.addEventListener('click', function () {
        requestSlideIntent('variant');
        scheduleOptionRerender();
      });
    });

    if (typeof MutationObserver !== 'undefined') {
      var optionObserverTargets = document.querySelectorAll(
        'div.option_colour_tone, .option_colour_tone, div.option_frame_colour_new, .option_frame_colour_new, .option_frame_colour, .option_frame_colour_canvas'
      );
      optionObserverTargets.forEach(function (target) {
        var observer = new MutationObserver(function () {
          scheduleOptionRerender();
        });
        observer.observe(target, {
          subtree: true,
          childList: true,
          attributes: false
        });
      });
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (
        target.matches('input[name="properties[Colour tone]"]') ||
        target.matches('input[name="properties[Frame colour]"]')
      ) {
        requestSlideIntent('variant');
        scheduleOptionRerender();
      }
    });

    document.addEventListener('variant:change', function () {
      rerender();
      if (!mobilePerfOptimized) window.setTimeout(rerender, 120);
    });

    window.addEventListener('resize', function () {
      if (!mobilePerfOptimized) syncStickyCompactUi();
      rerender();
    });
    window.addEventListener('orientationchange', function () {
      if (!mobilePerfOptimized) syncStickyCompactUi();
      rerender();
    });
    function onVisualiserImageLoad() {
      if (mobilePerfOptimized) optimizedImageFollowup = true;
      rerender();
    }
    if (els.artImage) els.artImage.addEventListener('load', onVisualiserImageLoad);
    if (els.sceneImage) els.sceneImage.addEventListener('load', onVisualiserImageLoad);

    var visualiserSlide = root.closest ? root.closest('.product-main-slide') : null;
    function isSlideShown() {
      if (ENABLE_BLANKWALL_SCENE && state.scene === 'blankwall' && shouldShowExpandedToneSwitch()) {
        if (!visualiserSlide) return isRootInViewport();
        if (visualiserSlide.getAttribute('aria-hidden') !== 'true' && visualiserSlide.classList.contains('is-selected')) {
          return true;
        }
        return isRootInViewport();
      }
      if (!visualiserSlide) return true;
      if (visualiserSlide.getAttribute('aria-hidden') === 'true') return false;
      return visualiserSlide.classList.contains('is-selected');
    }
    function scheduleShownRenders() {
      [0, 160, 420].forEach(function (delay) {
        window.setTimeout(function () {
          requestRender();
        }, delay);
      });
      scheduleVisualiserPreload({ includeSceneBackgrounds: true });
    }
    if (visualiserSlide && typeof MutationObserver !== 'undefined') {
      var wasShown = isSlideShown();
      var slideObserver = new MutationObserver(function () {
        var shown = isSlideShown();
        if (shown && !wasShown) {
          scheduleShownRenders();
        }
        wasShown = shown;
      });
      slideObserver.observe(visualiserSlide, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    }

    if (typeof MutationObserver !== 'undefined') {
      Array.from(document.querySelectorAll('.custom-product-single__sticky')).forEach(function (stickyPanel) {
        var stickyUiObserver = new MutationObserver(function () {
          syncStickyCompactUi();
          window.requestAnimationFrame(syncStickyCompactUi);
          if (
            mobilePerfOptimized &&
            Number(window.__umStickyPreviewVisibleUntil || 0) > Date.now()
          ) {
            requestRender(true);
          }
        });
        stickyUiObserver.observe(stickyPanel, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }
    document.addEventListener('um:sticky-preview-state', function (event) {
      if (event && event.detail && event.detail.open === true) {
        root.classList.add('pdpv3m-sticky-compact');
        if (mobilePerfOptimized) {
          window.requestAnimationFrame(function () {
            requestRender(true);
          });
        }
      }
      syncStickyCompactUi();
      window.requestAnimationFrame(syncStickyCompactUi);
      window.setTimeout(syncStickyCompactUi, 80);
    });

    function isRootInViewport() {
      var anchor = (root && root.closest && root.closest('.product__main-photos')) || root;
      if (!anchor || !anchor.getBoundingClientRect) return true;
      var rect = anchor.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      return rect.width > 0 &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < viewportHeight &&
        rect.left < viewportWidth;
    }

    function scheduleInitialRender() {
      var didRender = false;

      function run() {
        if (didRender) return;
        didRender = true;
        requestRender();
        scheduleVisualiserPreload({ includeSceneBackgrounds: false });
      }

      if (isRootInViewport()) {
        run();
        return;
      }

      if ('IntersectionObserver' in window) {
        var initialObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            initialObserver.disconnect();
            run();
          });
        }, { threshold: 0.05 });
        initialObserver.observe(root);
      }

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1800 });
      } else {
        window.setTimeout(run, 900);
      }
    }

    function bindFlickityRenderHook() {
      var carousel = document.querySelector('.product-slideshow');
      if (!carousel || !(window.Flickity && window.Flickity.data)) return false;
      var flkty = window.Flickity.data(carousel);
      if (!flkty || typeof flkty.on !== 'function' || typeof flkty.getCellElements !== 'function') return false;
      if (!visualiserSlide) return false;

      var slideCellIndex = -1;
      var cells = flkty.getCellElements() || [];
      for (var i = 0; i < cells.length; i += 1) {
        if (cells[i] === visualiserSlide) {
          slideCellIndex = i;
          break;
        }
      }
      if (slideCellIndex < 0) return false;

      function onSelect(index) {
        if (Number(index) !== slideCellIndex) return;
        requestRender();
        if (!mobilePerfOptimized) window.setTimeout(requestRender, 120);
      }

      flkty.on('select', onSelect);
      flkty.on('settle', onSelect);
      return true;
    }

    if ('IntersectionObserver' in window) {
      var renderVisibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          flushDeferredRender();
        });
      }, { threshold: 0.02 });
      renderVisibilityObserver.observe(root);
    }

    (function tryBindFlickityHook(attempt) {
      if (bindFlickityRenderHook()) return;
      if (attempt >= 12) return;
      window.setTimeout(function () {
        tryBindFlickityHook(attempt + 1);
      }, 180);
    })(0);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      window.setTimeout(flushDeferredRender, 40);
    });

    root.addEventListener('pdpv3:force-render', function () {
      requestRender(true);
    });

    scheduleInitialRender();
    syncStickyCompactUi();
  });
})();
